import MotivationStats from './MotivationStats';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import StatusProgres from '../../progressbar/StatusProgres';
import './chaptercontainer.css';

import ExplanationLesson from './quizTypes/ExplanationLesson/ExplanationLesson';
import LessonActionBar from './LessonActionBar/LessonActionBar';
import FormulaExplanationLesson from './quizTypes/FormulaExplanationLesson/FormulaExplanationLesson';
import SimpleSelectQuiz from './quizTypes/SimpleSelectQuiz/SimpleSelectQuiz';
import SimpleApplication from './quizTypes/SimpleApplication/SimpleApplication';
import MultipleSelectQuiz from './quizTypes/MultipleSelectQuiz/MultipleSelectQuiz';
import DragAndDropHorizontal from './quizTypes/DragAndDropHorizontal/DragAndDropHorizontal';
import DecisionFlowApplication from './quizTypes/DecisionFlowApplication/DecisionFlowApplication';
import FeedBackLesson from './quizTypes/FeedBackLesson/FeedBackLesson';
import GeneralOptionDrag from './quizTypes/GeneralOptionDrag/GeneralOptionDrag';
import ClassificationOption from './quizTypes/ClassificationOption/ClassificationOption';
import AssociationOption from './quizTypes/AssociationOption/AssociationOption';
import LessonCompletion from './quizTypes/LessonCompletion/LessonCompletion';
import FormulaDragAndDrop from './quizTypes/FormulaDragAndDrop/FormulaDragAndDrop';




import '../../styles/darkmode.css';
import PracticeHelpPopup from './PracticeHelpPopup';
import final_congrats_conti from '../../imagesHome/final_congrats_conti.png';
import finishflag from '../../imagesHome/finish-flag.png';
import changecard from '../../imagesHome/change-card.png';
import infoButton from '../../imagesHome/info.png';
import Junphereconti from '../../imagesHome/Junphereconti.png';
import boltImg from '../../imagesHome/bolt.png';
import coinImg from '../../header/images/coin.png';
import contiRevendicare from '../../imagesHome/conti_revendicare.png';
import contiRevendicat from '../../imagesHome/revendicat.png';


import confettyFinish from '../../imagesHome/confettyFinish.gif';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faThumbsDown, faStar, faSquareCheck } from "@fortawesome/free-regular-svg-icons";
import { faCheckDouble, faGift } from "@fortawesome/free-solid-svg-icons";
import StreakDisplay from './StreakDisplay';



import { useCallback } from 'react';
import levelUp from '../../header/images/level-up.mp3';
import error from '../../header/images/error.mp3';
import CustomAlert from '../../progressbar/CustomAlert'; 
import FeedbackPopup from '../../popuplessons/FeedbackPopup';
import ExplanationPopup from '../../popuplessons/ExplanationPopup';

import fire from '../../imagesHome/fire.gif';
import NoLivesPopup from '../../progressbar/NoLivesPopup';

import Leaderboard from '../clasament/Leaderboard';

import { newAttemptId, trackQuizStart, trackQuizFinish } from '../../utils/track';













  // Adaugă URL-ul API-ului folosind variabila de mediu
  const apiUrl = process.env.REACT_APP_API_URL;

  // Adaugă această funcție pentru a iniția vibrația pe dispozitivele compatibile
const triggerVibration = (pattern) => {
  if (navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};




const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const ALLOWED_GIFT_REWARDS = ['lives', 'coins', 'xp'];

const normalizeGiftRewardKey = (value) => {
  if (value === null || value === undefined) return null;

  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return null;

  if (normalized === 'lives' || normalized === 'life' || normalized === 'viata' || normalized === 'vieti') {
    return 'lives';
  }

  if (normalized === 'coins' || normalized === 'coin' || normalized === 'monede' || normalized === 'moneda' || normalized === 'bani') {
    return 'coins';
  }

  if (normalized === 'xp') {
    return 'xp';
  }

  return null;
};

const normalizeGiftRewardList = (rawRewards) => {
  if (!rawRewards) return [];

  const values = Array.isArray(rawRewards)
    ? rawRewards
    : String(rawRewards)
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);

  const normalizedValues = values
    .map((value) => normalizeGiftRewardKey(value))
    .filter((value) => value !== null);

  return Array.from(new Set(normalizedValues));
};

const getGiftRewardKeysForQuestion = (question) => {
  const configuredRewards = [
    question?.giftRewards,
    question?.giftRewardTypes,
    question?.giftRewardType,
    question?.allowedGiftRewards,
    question?.rewardTypes,
    question?.rewardType
  ].reduce((accumulator, candidate) => {
    if (accumulator.length > 0) {
      return accumulator;
    }

    return normalizeGiftRewardList(candidate);
  }, []);

  const rewardsFromConfig = configuredRewards.filter((reward) => ALLOWED_GIFT_REWARDS.includes(reward));
  if (rewardsFromConfig.length > 0) {
    return rewardsFromConfig;
  }

  const rewardsFromFlags = [
    question?.giveLives && 'lives',
    question?.giveCoins && 'coins',
    question?.giveXp && 'xp'
  ].filter(Boolean);

  if (rewardsFromFlags.length > 0) {
    return rewardsFromFlags;
  }

  return [...ALLOWED_GIFT_REWARDS];
};

const getDefaultGiftReward = (question, giftRewardKeys) => {
  const normalizedDefaultReward = normalizeGiftRewardKey(question?.defaultGiftReward);

  if (normalizedDefaultReward && giftRewardKeys.includes(normalizedDefaultReward)) {
    return normalizedDefaultReward;
  }

  return giftRewardKeys[0] || 'lives';
};

const getGiftEffectLabel = ({ rewardKey, lives, coins, xp }) => {
  if (rewardKey === 'coins') {
    return `+${coins} coins`;
  }

  if (rewardKey === 'xp') {
    return `+${xp} XP`;
  }

  return `+${lives} vieti`;
};

// Formula explanation helper functions
const normalizeFormulaOptionKey = (key) =>
  String(key || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

const getExplanationItemHtml = (explanationItem) => {
  if (typeof explanationItem === 'string') {
    return explanationItem;
  }

  if (!explanationItem || typeof explanationItem !== 'object') {
    return '';
  }

  return (
    explanationItem.html ||
    explanationItem.description ||
    explanationItem.descriptionExplanation ||
    explanationItem.text ||
    ''
  );
};

const getFormulaExplanationRawOptions = (explanationItem, question, explanationIndex) => {
  const descriptionItems = Array.isArray(question?.descriptionExplanation)
    ? question.descriptionExplanation
    : [];
  const isLastDescription = explanationIndex === descriptionItems.length - 1;

  return (
    explanationItem?.options ??
    explanationItem?.formulaOptions ??
    (isLastDescription ? question?.options ?? question?.formulaOptions : null)
  );
};

const splitFormulaSideAccounts = (rawValue) => {
  if (rawValue === null || rawValue === undefined) return [];

  if (Array.isArray(rawValue)) {
    return rawValue
      .flatMap((item) => splitFormulaSideAccounts(item))
      .filter((item) => item !== '');
  }

  if (typeof rawValue === 'object') {
    const objectAccount =
      rawValue.account ??
      rawValue.cont ??
      rawValue.name ??
      rawValue.label ??
      null;

    if (objectAccount !== null && objectAccount !== undefined) {
      const normalized = String(objectAccount).trim();
      return normalized ? [normalized] : [];
    }

    return [];
  }

  const value = String(rawValue).trim();
  if (!value) return [];

  const parts = value
    .split(/\s*\/\s*|\s*;\s*|\s*\|\s*|\n+/)
    .map((item) => item.trim())
    .filter((item) => item !== '' && item !== '%');

  return parts.length > 0 ? parts : [value];
};

const getFormulaExplanationSides = (explanationItem, question, explanationIndex) => {
  const rawOptions = getFormulaExplanationRawOptions(explanationItem, question, explanationIndex);

  if (!rawOptions) {
    return { leftAccounts: [], rightAccounts: [], operator: '=' };
  }

  if (Array.isArray(rawOptions)) {
    const left = rawOptions[0] !== undefined ? [String(rawOptions[0]).trim()] : [];
    const operator = rawOptions[1] !== undefined ? String(rawOptions[1]).trim() : '=';
    const right = rawOptions[2] !== undefined ? [String(rawOptions[2]).trim()] : [];

    return {
      leftAccounts: left.filter(Boolean),
      rightAccounts: right.filter(Boolean),
      operator: operator || '='
    };
  }

  if (typeof rawOptions !== 'object') {
    return { leftAccounts: [], rightAccounts: [], operator: '=' };
  }

  const optionsObject = rawOptions;
  const explicitSides =
    optionsObject.sides && typeof optionsObject.sides === 'object'
      ? optionsObject.sides
      : null;

  const getByAliases = (aliases) => {
    const entries = Object.entries(optionsObject);
    const match = entries.find(([key]) => aliases.includes(normalizeFormulaOptionKey(key)));
    if (match) return match[1];

    if (explicitSides) {
      const sideEntries = Object.entries(explicitSides);
      const sideMatch = sideEntries.find(([key]) => aliases.includes(normalizeFormulaOptionKey(key)));
      if (sideMatch) return sideMatch[1];
    }

    return null;
  };

  const leftRaw = getByAliases([
    'cont1', 'contul1', 'account1', 'leftaccount', 'left', 'debit', 'debitaccounts', 'leftaccounts'
  ]);
  const rightRaw = getByAliases([
    'cont2', 'contul2', 'account2', 'rightaccount', 'right', 'credit', 'creditaccounts', 'rightaccounts'
  ]);
  const operatorRaw = getByAliases(['operator', 'semn', 'sign', 'equals', 'egal', 'eq']);

  return {
    leftAccounts: splitFormulaSideAccounts(leftRaw),
    rightAccounts: splitFormulaSideAccounts(rightRaw),
    operator: String(operatorRaw ?? '=').trim() || '='
  };
};

const getFormulaExplanationParts = (explanationItem, question, explanationIndex) => {
  const rawOptions = getFormulaExplanationRawOptions(explanationItem, question, explanationIndex);

  if (Array.isArray(rawOptions)) {
    return rawOptions
      .filter((part) => {
        if (part === null || part === undefined) return false;
        if (typeof part === 'object') return false;
        return String(part).trim() !== '';
      })
      .map((part) => String(part));
  }

  if (rawOptions && typeof rawOptions === 'object') {
    const rowCollectionKeys = new Set([
      'rows',
      'formularows',
      'compoundrows',
      'entries',
      'lines',
      'breakdown',
      'detalii',
      'detaliere'
    ]);

    const entries = Object.entries(rawOptions).filter(([key, value]) => {
      if (value === null || value === undefined) return false;
      if (typeof value === 'object') return false;
      if (rowCollectionKeys.has(normalizeFormulaOptionKey(key))) return false;
      return String(value).trim() !== '';
    });

    const groupedKeys = [
      ['cont1', 'contul1', 'account1', 'leftaccount', 'left', 'debit'],
      ['operator', 'semn', 'sign', 'equals', 'egal', 'eq'],
      ['cont2', 'contul2', 'account2', 'rightaccount', 'right', 'credit'],
      ['suma', 'sum', 'amount', 'valoare']
    ];

    const usedKeys = new Set();
    const orderedParts = [];

    groupedKeys.forEach((keyGroup) => {
      const match = entries.find(([key]) => keyGroup.includes(normalizeFormulaOptionKey(key)));
      if (!match) return;

      usedKeys.add(match[0]);
      orderedParts.push(String(match[1]));
    });

    entries.forEach(([key, value]) => {
      if (usedKeys.has(key)) return;
      orderedParts.push(String(value));
    });

    return orderedParts;
  }

  return [];
};

const getFormulaExplanationRows = (explanationItem, question, explanationIndex) => {
  const rawOptions = getFormulaExplanationRawOptions(explanationItem, question, explanationIndex);

  if (!rawOptions || typeof rawOptions !== 'object') {
    return [];
  }

  const candidateRowKeys = [
    'rows',
    'formulaRows',
    'compoundRows',
    'entries',
    'lines',
    'breakdown',
    'detalii',
    'detaliere'
  ];

  const rowCollection = candidateRowKeys
    .map((key) => rawOptions[key])
    .find((value) => Array.isArray(value));

  if (Array.isArray(rowCollection)) {
    return rowCollection
      .map((row) => {
        if (typeof row === 'string') {
          const trimmed = row.trim();
          return trimmed ? { account: trimmed, amount: '' } : null;
        }

        if (!row || typeof row !== 'object') {
          return null;
        }

        const account =
          row.cont ??
          row.account ??
          row.accountCode ??
          row.code ??
          row.contul ??
          '';
        const amount =
          row.suma ??
          row.amount ??
          row.value ??
          row.valoare ??
          '';

        const normalizedAccount = String(account).trim();
        const normalizedAmount = String(amount).trim();

        if (!normalizedAccount && !normalizedAmount) return null;

        return {
          account: normalizedAccount,
          amount: normalizedAmount
        };
      })
      .filter((row) => row !== null);
  }

  return [];
};


const Chaptercontainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Check if navigation state exists (user did not come from a lesson link)
  useEffect(() => {
    // If accessed directly (no state or missing chapterId/lessonId), redirect
    if (!location.state || !location.state.chapterId || !location.state.lessonId) {
      navigate('/functionalpagelogin', { replace: true });
    }
  }, [location, navigate]);

  const buildDecisionOptionId = (index) => `decision-opt-${index}`;

  const extractDecisionOptionIndex = (optionId) => {
    if (typeof optionId !== 'string') return -1;
    if (!optionId.startsWith('decision-opt-')) return -1;
    const value = Number(optionId.replace('decision-opt-', ''));
    return Number.isInteger(value) && value >= 0 ? value : -1;
  };



  const [
  associationAnswers,
  setAssociationAnswers
] = useState({});







  const getDecisionOptionValueById = (step, optionId) => {
    const index = extractDecisionOptionIndex(optionId);
    if (index !== -1) {
      if (!Array.isArray(step?.options)) return null;
      return step.options[index] ?? null;
    }

    if (optionId === null || optionId === undefined || optionId === '') {
      return null;
    }

    return optionId;
  };

  const buildGeneralOptionId = (index) => `general-opt-${index}`;

  const extractGeneralOptionIndex = (optionId) => {
    if (typeof optionId !== 'string') return -1;
    if (!optionId.startsWith('general-opt-')) return -1;
    const value = Number(optionId.replace('general-opt-', ''));
    return Number.isInteger(value) && value >= 0 ? value : -1;
  };

  const getGeneralOptionValueById = (question, optionId) => {
    const index = extractGeneralOptionIndex(optionId);
    if (index === -1) return null;
    if (!Array.isArray(question?.options)) return null;
    return question.options[index] ?? null;
  };

  const getDecisionDragSlotsCount = (step) => {
    if (!step || typeof step !== 'object') return 0;
    const explicitCount = Number(step.slotsCount);
    if (Number.isFinite(explicitCount) && explicitCount > 0) {
      return explicitCount;
    }
    if (Array.isArray(step.rows)) {
      const rowsCount = step.rows.reduce((sum, row) => {
        const slots = Number(row?.slots);
        return sum + (Number.isFinite(slots) && slots > 0 ? slots : 0);
      }, 0);
      if (rowsCount > 0) return rowsCount;
    }
    return Array.isArray(step.correctAnswer) ? step.correctAnswer.length : 0;
  };

const getActivPasivSplitConfig = (question) => {
  const slotsCount = getDecisionDragSlotsCount(question);
  const placementRaw = String(
    question?.placement ||
    question?.sidePlacement ||
    'both'
  ).toLowerCase();

  const placement = ['left', 'right', 'both'].includes(placementRaw)
    ? placementRaw
    : 'both';

  const configuredActivSlots = Number(question?.activSlots);
  const configuredPasivSlots = Number(question?.pasivSlots);

  const hasActivSlots =
    Number.isFinite(configuredActivSlots) &&
    configuredActivSlots >= 0;

  const hasPasivSlots =
    Number.isFinite(configuredPasivSlots) &&
    configuredPasivSlots >= 0;

  let activCount = 0;
  let pasivCount = 0;

  if (placement === 'left') {
    activCount = hasActivSlots
      ? configuredActivSlots
      : slotsCount;

    pasivCount = 0;
  } else if (placement === 'right') {
    activCount = 0;

    pasivCount = hasPasivSlots
      ? configuredPasivSlots
      : slotsCount;
  } else {
    if (hasActivSlots || hasPasivSlots) {
      activCount = hasActivSlots
        ? configuredActivSlots
        : Math.max(0, slotsCount - configuredPasivSlots);

      pasivCount = hasPasivSlots
        ? configuredPasivSlots
        : Math.max(0, slotsCount - configuredActivSlots);
    } else {
      activCount =
        slotsCount <= 1
          ? slotsCount
          : Math.ceil(slotsCount / 2);

      pasivCount = slotsCount - activCount;
    }
  }

  const resolvedSlotsCount = activCount + pasivCount;

  return {
    placement,
    slotsCount: resolvedSlotsCount,
    activCount,
    pasivCount
  };
};

  const buildHorizontalOptionId = (index) => `horizontal-opt-${index}`;

  const extractHorizontalOptionIndex = (optionId) => {
    if (typeof optionId !== 'string') return -1;
    if (!optionId.startsWith('horizontal-opt-')) return -1;
    const value = Number(optionId.replace('horizontal-opt-', ''));
    return Number.isInteger(value) && value >= 0 ? value : -1;
  };

  const getHorizontalOptionValue = (option) => {
    if (option && typeof option === 'object') {
      return option.code ?? option.value ?? option.label ?? '';
    }
    return option;
  };

  const normalizeHorizontalDragOptions = (question) => {
    if (!Array.isArray(question?.options)) return [];

    return question.options.reduce((acc, option, index) => {
      const value = getHorizontalOptionValue(option);
      const normalizedValue = value === null || value === undefined ? '' : String(value).trim();

      // Ignoram optiunile goale pentru a evita butoane fara text.
      if (!normalizedValue) {
        return acc;
      }

      acc.push({
        id: buildHorizontalOptionId(index),
        value: normalizedValue,
        label: option && typeof option === 'object'
          ? String(option.label ?? normalizedValue)
          : normalizedValue,
      });

      return acc;
    }, []);
  };

  const buildFormulaDragOptionId = (index) =>
  `formula-dnd-opt-${index}`;

const normalizeFormulaDragOptions = (question) => {
  if (!Array.isArray(question?.options)) {
    return [];
  }

  return question.options
    .map((option, index) => {
      if (
        option === null ||
        option === undefined
      ) {
        return null;
      }

      if (typeof option === 'object') {
        const value =
          option.value ??
          option.code ??
          option.label ??
          '';

        const label =
          option.label ??
          option.value ??
          option.code ??
          '';

        if (!String(value).trim()) {
          return null;
        }

        return {
          id:
            option.id ??
            buildFormulaDragOptionId(index),
          value: String(value),
          label: String(label),
        };
      }

      const value = String(option).trim();

      if (!value) {
        return null;
      }

      return {
        id: buildFormulaDragOptionId(index),
        value,
        label: value,
      };
    })
    .filter(Boolean);
};

  const getHorizontalDragSlotsCount = (question) => {
    if (!question || typeof question !== 'object') return 0;

    const explicitCount = Number(question.slotsCount);
    if (Number.isFinite(explicitCount) && explicitCount > 0) {
      return explicitCount;
    }

    if (Array.isArray(question.rows) && question.rows.length > 0) {
      const rowsCount = question.rows.reduce((sum, row) => {
        const slots = Number(row?.slots);
        return sum + (Number.isFinite(slots) && slots > 0 ? slots : 0);
      }, 0);
      if (rowsCount > 0) return rowsCount;
    }

    const countInlineSlotsFromParts = (parts) => {
      if (!Array.isArray(parts) || parts.length === 0) return 0;
      return parts.reduce((count, part) => {
        const text = String(part ?? '');
        const isSlot =
          text === '__SLOT__' ||
          text === '{{slot}}' ||
          /^_{3,}$/.test(text);
        return count + (isSlot ? 1 : 0);
      }, 0);
    };

    const countInlineSlotsFromTemplate = (template) => {
      if (typeof template !== 'string' || template.trim() === '') return 0;
      const matches = template.match(/\{\{slot\}\}|_{3,}/g);
      return Array.isArray(matches) ? matches.length : 0;
    };

    const sentencePartsCount = countInlineSlotsFromParts(question.sentenceParts);
    if (sentencePartsCount > 0) return sentencePartsCount;

    const sentenceTemplateCount = countInlineSlotsFromTemplate(question.sentenceTemplate);
    if (sentenceTemplateCount > 0) return sentenceTemplateCount;

    const questionInlineCount = countInlineSlotsFromTemplate(question.question);
    if (questionInlineCount > 0) return questionInlineCount;

    if (!Array.isArray(question.correctAnswer)) {
      return 0;
    }

    return question.correctAnswer.filter((_, index) => index % 2 === 1).length;
  };

  const getHorizontalDragRows = (question) => {
    if (Array.isArray(question?.rows) && question.rows.length > 0) {
      return question.rows;
    }

    return [{ label: '', slots: getHorizontalDragSlotsCount(question) }];
  };

  const getHorizontalDragExpectedAnswers = (question) => {
    if (!Array.isArray(question?.correctAnswer)) return [];

    if (Array.isArray(question.rows) && question.rows.length > 0) {
      return question.correctAnswer;
    }

    const slotsCount = getHorizontalDragSlotsCount(question);
    if (question.correctAnswer.length === slotsCount) {
      return question.correctAnswer;
    }

    return question.correctAnswer.filter((_, index) => index % 2 === 1);
  };

  const getHorizontalSentenceSegments = (question) => {
    if (!question || typeof question !== 'object') return [];

    if (Array.isArray(question.sentenceParts) && question.sentenceParts.length > 0) {
      return question.sentenceParts;
    }

    if (typeof question.sentenceTemplate === 'string' && question.sentenceTemplate.trim() !== '') {
      const parts = question.sentenceTemplate
        .split(/(\{\{slot\}\}|_{3,})/g)
        .filter((item) => item !== '');

      if (parts.length > 0) {
        return parts;
      }
    }

    if (typeof question.question === 'string' && /\{\{slot\}\}|_{3,}/.test(question.question)) {
      const parts = question.question
        .split(/(\{\{slot\}\}|_{3,})/g)
        .filter((item) => item !== '');

      if (parts.length > 0) {
        return parts;
      }
    }

    // Fallback pentru structura veche: textul era alternat cu raspunsurile corecte.
    if (Array.isArray(question.correctAnswer) && question.correctAnswer.length > 1) {
      const hasRows = Array.isArray(question.rows) && question.rows.length > 0;
      const hasExplicitSlots = Number(question.slotsCount) > 0;

      if (!hasRows && !hasExplicitSlots) {
        return question.correctAnswer.map((item, index) => (index % 2 === 1 ? '__SLOT__' : item));
      }
    }

    return [];
  };

  const getHorizontalOptionValueById = (question, optionId) => {
    const index = extractHorizontalOptionIndex(optionId);
    if (index === -1) {
      if (optionId === null || optionId === undefined || optionId === '') return null;
      return optionId;
    }

    if (!Array.isArray(question?.options)) return null;
    const option = question.options[index];
    const value = getHorizontalOptionValue(option);
    if (value === null || value === undefined || value === '') return null;
    return String(value);
  };


const userId = localStorage.getItem("userId");

const feedbackLessonRef = useRef(null);

const [
  hasLessonFeedback,
  setHasLessonFeedback
] = useState(false);


  const [shuffledOptions, setShuffledOptions] = useState([]);
  const [shuffledMultipleOptions, setShuffledMultipleOptions] = useState([]);
  const [shuffledApplicationOptions, setShuffledApplicationOptions] = useState([]);

  const [shuffledDragHorizontalOptions, setShuffledDragHorizontalOptions] = useState([]);
  const [shuffledDecisionOptions, setShuffledDecisionOptions] = useState([]);
  const [shuffledDecisionDragOptions, setShuffledDecisionDragOptions] = useState([]);
  const [shuffledGeneralDragOptions, setShuffledGeneralDragOptions] = useState([]);
  const [shuffledOptionDragAndDropFormulaLeftOptions, setShuffledOptionDragAndDropFormulaLeftOptions] = useState([]);
  const [shuffledOptionDragAndDropFormulaRightOptions, setShuffledOptionDragAndDropFormulaRightOptions] = useState([]);

  const [
  formulaDragAnswers,
  setFormulaDragAnswers
] = useState({});

const [
  shuffledFormulaDragOptions,
  setShuffledFormulaDragOptions
] = useState([]);


  const [cardIndex, setCardIndex] = useState(0);

const handleCardChange = useCallback((nextIndex) => {
  setCardIndex(nextIndex);
}, []);


  const [hasUnlockedExplanationContinue, setHasUnlockedExplanationContinue] = useState(false);





const handleDecisionMultipleAnswer = useCallback(
  (option) => {
    setDecisionSelectedAnswers(
      (previousAnswers) => {
        const nextAnswers =
          previousAnswers.includes(option)
            ? previousAnswers.filter(
                (answer) =>
                  answer !== option
              )
            : [
                ...previousAnswers,
                option,
              ];

        setDesableButton(
          nextAnswers.length === 0
        );

        if (nextAnswers.length > 0) {
          setTextButton('Verifica');
          setChangeColorButton(true);
        }

        return nextAnswers;
      }
    );
  },
  []
);



const handleUnlockExplanationContinue = useCallback(() => {
  setHasUnlockedExplanationContinue(true);
}, []);





  const [lives, setLives] = useState(3);
  const [coinCount, setCoinCount] = useState(0);
  const [xp, setXp] = useState(0);
  const [correctStreak, setCorrectStreak] = useState(0);

// 🔥 statistici DOAR pentru lecția curentă
const [lessonCoins, setLessonCoins] = useState(0);
const [lessonXp, setLessonXp] = useState(0);
const [correctAnswersCount, setCorrectAnswersCount] = useState(0);
const [wrongAnswersCount, setWrongAnswersCount] = useState(0);
const [selectedGiftReward, setSelectedGiftReward] = useState('lives');
const [giftRewardClaimed, setGiftRewardClaimed] = useState(false);
const [isGiftClaimProcessing, setIsGiftClaimProcessing] = useState(false);
const [giftClaimEffectLabel, setGiftClaimEffectLabel] = useState('');
const [showGiftClaimEffect, setShowGiftClaimEffect] = useState(false);
const giftClaimEffectTimeoutRef = useRef(null);

  

const [selectedRating, setSelectedRating] = useState(0);
const [showRatingMessage, setShowRatingMessage] = useState(false);
const [showRatingSection, setShowRatingSection] = useState(false);
const [decisionStepIndex, setDecisionStepIndex] = useState(0);
const [decisionAnswer, setDecisionAnswer] = useState(null);
const [decisionSelectedAnswers, setDecisionSelectedAnswers] = useState([]); // Pentru multipleOption
const [decisionDragAnswer, setDecisionDragAnswer] = useState([]); // Pentru optionDragAndDrop
const [selectedDecisionDragOptionId, setSelectedDecisionDragOptionId] = useState(null);
const [generalDragAnswer, setGeneralDragAnswer] = useState([]); // Pentru generalOptionDrag

const [
  classificationAnswers,
  setClassificationAnswers
] = useState({});

const [orderSelectedSlotIndex, setOrderSelectedSlotIndex] = useState(null);
const [decisionPhase, setDecisionPhase] = useState('intro');
const touchDecisionOptionIdRef = useRef(null);
const touchDecisionStartRef = useRef({ x: 0, y: 0 });
const touchDecisionMovedRef = useRef(false);
const touchDecisionHoveredSlotRef = useRef(null);
const touchDecisionPreviewRef = useRef(null);
const touchDecisionSourceRef = useRef(null);
// 'intro' | 'steps' | 'final'


const [showPracticeHelp, setShowPracticeHelp] = useState(false);
const [soundEffectsEnabled, setSoundEffectsEnabled] = useState(true);




  const handleDecisionSimpleAnswer = useCallback(
  (option) => {
    setDecisionAnswer(option);

    setDesableButton(false);
    setTextButton('Verifica');
    setChangeColorButton(true);
  },
  []
);





const handleGeneralDragAnswerChange =
  useCallback((nextAnswers) => {
    setGeneralDragAnswer(
      nextAnswers
    );

    const allSlotsFilled =
      Array.isArray(nextAnswers) &&
      nextAnswers.length > 0 &&
      nextAnswers.every(
        (answer) =>
          answer !== null &&
          answer !== undefined &&
          answer !== ''
      );

    setDesableButton(
      !allSlotsFilled
    );

    if (allSlotsFilled) {
      setTextButton('Verifica');
      setChangeColorButton(true);
    }
  }, []);



const handleHorizontalDragAnswersChange =
  useCallback((nextAnswers) => {
    const safeNextAnswers =
      Array.isArray(nextAnswers)
        ? nextAnswers
        : [];

    setDataReceived(
      safeNextAnswers
    );

    const allSlotsFilled =
      safeNextAnswers.length > 0 &&
      safeNextAnswers.every(
        (answer) =>
          answer !== null &&
          answer !== undefined &&
          answer !== ''
      );

    setDesableButton(
      !allSlotsFilled
    );

    setTextButton('Verifica');
    setChangeColorButton(
      allSlotsFilled
    );
  }, []);








const ignoredForProgress = [
  'lessonResume',
  'JustInTimeMotivation',
  'serieCompleta',
  'deblocarePremium',
  'clasament',
  'lessonCompletion',
  'feedbackLesson',
];

useEffect(() => {
  const fetchSoundPreference = async () => {
    try {
      const response = await fetch(`${apiUrl}/user`, {
        method: 'GET',
        credentials: 'include',
      });

      if (!response.ok) return;

      const data = await response.json();
      if (typeof data.sound_effects === 'boolean') {
        setSoundEffectsEnabled(data.sound_effects);
      }
    } catch (error) {
      console.error('Eroare la preluarea preferintelor de sunet:', error);
    }
  };

  fetchSoundPreference();
}, []);

const playSoundEffect = useCallback((soundFile) => {
  if (!soundEffectsEnabled) return;

  const audio = new Audio(soundFile);
  audio.play().catch(() => {});
}, [soundEffectsEnabled]);





const handleRating = (value) => {
  setSelectedRating(value);

  // ascunde mesajul întâi
  setShowRatingMessage(false);

  // afișează după 0.2s
  setTimeout(() => {
    setShowRatingMessage(true);
  }, 200);

  handleFeedback(value);
};



    // ...existing code...
  const {
    chapterId,
    lessonId,
    lessonData: lessonDataFromState,
    isReplayLesson: isReplayLessonFromState
  } = location.state || {}; // Primește chapterId și lessonId
  const isReplayLesson = Boolean(isReplayLessonFromState);
  const [lessonData, setLessonData] = useState(null);
  const [nextQuestion, setNextQuestion] = useState(0);
  const [showJumpHereIntro, setShowJumpHereIntro] = useState(false);

const handleFormulaDragAnswersChange =
  useCallback((nextAnswers) => {
    const safeNextAnswers =
      nextAnswers &&
      typeof nextAnswers === 'object' &&
      !Array.isArray(nextAnswers)
        ? nextAnswers
        : {};

    setFormulaDragAnswers(safeNextAnswers);

    const currentQuestion =
      lessonData?.questions?.[nextQuestion];

    const formulaQuestion =
      currentQuestion?.type === 'decisionFlowApplication'
        ? currentQuestion.steps?.[decisionStepIndex]
        : currentQuestion;

    const expectedAnswers =
      formulaQuestion?.correctAnswer &&
      typeof formulaQuestion.correctAnswer === 'object' &&
      !Array.isArray(formulaQuestion.correctAnswer)
        ? formulaQuestion.correctAnswer
        : {};

    const requiredSlotIds =
      Object.keys(expectedAnswers);

    const allSlotsFilled =
      requiredSlotIds.length > 0 &&
      requiredSlotIds.every(
        (slotId) =>
          safeNextAnswers[slotId] !== null &&
          safeNextAnswers[slotId] !== undefined &&
          safeNextAnswers[slotId] !== ''
      );

    setDesableButton(!allSlotsFilled);

    setTextButton('Verifica');

    setChangeColorButton(allSlotsFilled);
  }, [
    lessonData,
    nextQuestion,
    decisionStepIndex,
  ]);





  

  // Telemetrie quiz pentru panoul admin: quiz_start la deschiderea lecției,
  // quiz_finish la finalizare (același attempt_id) — vezi utils/track.js.
  const quizAttemptRef = useRef(null);
  useEffect(() => {
    if (chapterId == null || lessonId == null) return;
    const id = newAttemptId();
    quizAttemptRef.current = id;
    trackQuizStart(id, { chapterId: Number(chapterId), lessonId: Number(lessonId), course: 'bazele' });
  }, [chapterId, lessonId]);



    
const handleClassificationAnswersChange =
  useCallback((nextAnswers) => {
    const safeNextAnswers =
      nextAnswers &&
      typeof nextAnswers === 'object' &&
      !Array.isArray(nextAnswers)
        ? nextAnswers
        : {};

    setClassificationAnswers(
      safeNextAnswers
    );

const currentQuestion =
  lessonData?.questions?.[
    nextQuestion
  ];

const currentClassificationQuestion =
  currentQuestion?.type ===
  'decisionFlowApplication'
    ? currentQuestion.steps?.[
        decisionStepIndex
      ]
    : currentQuestion;

const requiredSlotsCount =
  Array.isArray(
    currentClassificationQuestion?.categories
  )


        ? currentClassificationQuestion.categories.reduce(
            (total, category) => {
              const slots =
                Number(
                  category?.slots
                );

              return (
                total +
                (
                  Number.isFinite(slots) &&
                  slots > 0
                    ? slots
                    : 0
                )
              );
            },
            0
          )
        : 0;

    const placedOptionsCount =
      Object.values(
        safeNextAnswers
      )
        .filter(Array.isArray)
        .reduce(
          (total, categoryAnswers) =>
            total +
            categoryAnswers.length,
          0
        );

    const allSlotsFilled =
      requiredSlotsCount > 0 &&
      placedOptionsCount ===
        requiredSlotsCount;

    setDesableButton(
      !allSlotsFilled
    );

    setTextButton('Verifica');

    setChangeColorButton(
      allSlotsFilled
    );
  }, [
    lessonData,
    nextQuestion,
    decisionStepIndex,
  ]);





  


const handleAssociationAnswersChange =
  useCallback((nextAnswers) => {
    const safeNextAnswers =
      nextAnswers &&
      typeof nextAnswers === 'object' &&
      !Array.isArray(nextAnswers)
        ? nextAnswers
        : {};

    setAssociationAnswers(
      safeNextAnswers
    );

    /*
     * AssociationOption se verifica
     * automat in componenta.
     */
    setDesableButton(true);
    setTextButton('');
    setChangeColorButton(false);
  }, []);

  
// 🔥 OPREȘTE LECȚIA CÂND VIEȚILE AJUNG LA 0
const [showNoLivesPopup, setShowNoLivesPopup] = useState(false);


useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];











  if (!currentQuestion) return;

  if (currentQuestion.type === 'simpleSelect') {
    setShuffledOptions(shuffleArray(currentQuestion.options));
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
  
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'multipleSelect') {
    setShuffledMultipleOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledApplicationOptions([]);
  
    setShuffledDragHorizontalOptions([]);
  }


if (
  currentQuestion.type ===
  'simpleApplication'
) {
  const applicationType =
    currentQuestion.applicationType ||
    'simpleSelect';

  if (
    applicationType ===
    'dragAndDropHorizontal'
  ) {
    const normalizedOptions =
      normalizeHorizontalDragOptions(
        currentQuestion
      );

    setShuffledApplicationOptions(
      shuffleArray(
        normalizedOptions
      )
    );

    const slotsCount =
      getHorizontalDragSlotsCount(
        currentQuestion
      );

    setDataReceived(
      Array(slotsCount).fill(null)
    );
  } else if (
    applicationType ===
    'generalOptionDrag'
  ) {
    const normalizedOptions =
      Array.isArray(
        currentQuestion.options
      )
        ? currentQuestion.options.map(
            (value, index) => ({
              id: buildGeneralOptionId(
                index
              ),
              value,
              label: String(value),
            })
          )
        : [];

    setShuffledApplicationOptions(
      shuffleArray(
        normalizedOptions
      )
    );

    const slotsCount =
      getDecisionDragSlotsCount(
        currentQuestion
      );

    setGeneralDragAnswer(
      Array(slotsCount).fill(null)
    );

    setDesableButton(true);
    setTextButton('Verifica');
    setChangeColorButton(false);
  } else {
    setShuffledApplicationOptions(
      shuffleArray(
        currentQuestion.options || []
      )
    );
  }

  setShuffledOptions([]);
  setShuffledMultipleOptions([]);
  setShuffledDragHorizontalOptions([]);
}



  if (currentQuestion.type === 'dragAndDropHorizontal') {
    setShuffledDragHorizontalOptions(shuffleArray(normalizeHorizontalDragOptions(currentQuestion)));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);

  }

  if (
  currentQuestion.type ===
  'formulaDragAndDrop'
) {
  const normalizedOptions =
    normalizeFormulaDragOptions(
      currentQuestion
    );

  setShuffledFormulaDragOptions(
    shuffleArray(
      normalizedOptions
    )
  );

  const correctAnswer =
    currentQuestion.correctAnswer &&
    typeof currentQuestion.correctAnswer ===
      'object' &&
    !Array.isArray(
      currentQuestion.correctAnswer
    )
      ? currentQuestion.correctAnswer
      : {};

  const initialAnswers =
    Object.keys(correctAnswer).reduce(
      (result, slotId) => {
        result[slotId] = null;
        return result;
      },
      {}
    );

  setFormulaDragAnswers(
    initialAnswers
  );

  setDesableButton(true);
  setTextButton('Verifica');
  setChangeColorButton(false);

  setShuffledOptions([]);
  setShuffledMultipleOptions([]);
  setShuffledApplicationOptions([]);
  setShuffledDragHorizontalOptions([]);
}



  if (currentQuestion.type === 'optionDragAndDropFormulaLeft') {
    setShuffledOptionDragAndDropFormulaLeftOptions(shuffleArray(currentQuestion.options || []));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
  
    setShuffledDragHorizontalOptions([]);
    setShuffledGeneralDragOptions([]);
  }

  if (currentQuestion.type === 'optionDragAndDropFormulaRight') {
    setShuffledOptionDragAndDropFormulaRightOptions(shuffleArray(currentQuestion.options || []));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);

    setShuffledDragHorizontalOptions([]);
    setShuffledGeneralDragOptions([]);
  }
}, [lessonData, nextQuestion]);

useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (!currentQuestion || currentQuestion.type !== 'giftlesson') {
    return;
  }

  const giftRewardKeys = getGiftRewardKeysForQuestion(currentQuestion);
  const effectiveGiftRewardKeys = isReplayLesson
    ? giftRewardKeys.filter((rewardKey) => rewardKey !== 'coins')
    : giftRewardKeys;
  const defaultReward = getDefaultGiftReward(currentQuestion, giftRewardKeys);

  setSelectedGiftReward(
    effectiveGiftRewardKeys.includes(defaultReward)
      ? defaultReward
      : (effectiveGiftRewardKeys[0] || defaultReward)
  );
  setGiftRewardClaimed(false);
  setIsGiftClaimProcessing(false);
  setGiftClaimEffectLabel('');
  setShowGiftClaimEffect(false);
}, [lessonData, nextQuestion, isReplayLesson]);

useEffect(() => {
  return () => {
    if (giftClaimEffectTimeoutRef.current) {
      clearTimeout(giftClaimEffectTimeoutRef.current);
    }
  };
}, []);



useEffect(() => {
  setCardIndex(0);
  setHasUnlockedExplanationContinue(false);
}, [nextQuestion]);

useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (!currentQuestion) {
    return;
  }

  const isExplanationCardLessonType =
    currentQuestion.type === 'explanationLesson' ||
    currentQuestion.type === 'formulaExplanationLesson';

  if (!isExplanationCardLessonType) {
    return;
  }

  const cardsFromDescription = Array.isArray(currentQuestion.descriptionExplanation)
    ? currentQuestion.descriptionExplanation.length
    : 0;
  const totalCardsForQuestion =
    cardsFromDescription + (currentQuestion.type === 'formulaExplanationLesson' ? 1 : 0);

  if (totalCardsForQuestion <= 1) {
    setHasUnlockedExplanationContinue(true);
    return;
  }

  if (cardIndex === totalCardsForQuestion - 1) {
    setHasUnlockedExplanationContinue(true);
  }
}, [lessonData, nextQuestion, cardIndex]);











useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (!currentQuestion) return;
  if (currentQuestion.type !== 'decisionFlowApplication') return;

  const step = currentQuestion.steps?.[decisionStepIndex];
  if (!step) return;
if (
  step.type ===
  'formulaDragAndDrop'
) {
  const normalizedOptions =
    normalizeFormulaDragOptions(
      step
    );

  setShuffledFormulaDragOptions(
    shuffleArray(
      normalizedOptions
    )
  );

  const correctAnswer =
    step.correctAnswer &&
    typeof step.correctAnswer ===
      'object' &&
    !Array.isArray(
      step.correctAnswer
    )
      ? step.correctAnswer
      : {};

  const initialAnswers =
    Object.keys(
      correctAnswer
    ).reduce(
      (result, slotId) => {
        result[slotId] = null;
        return result;
      },
      {}
    );

  setFormulaDragAnswers(
    initialAnswers
  );

  setIsAnswerChecked(false);
  setAnswerStatus(null);
  setDesableButton(true);
  setTextButton('Verifica');
  setChangeColorButton(false);

  return;
}




  const stepOptionType =
  step.optionType ||
  step.stepType ||
  step.type;

if (
  stepOptionType ===
  'classificationOption'
) {
  const initialAnswers = {};

  const categories =
    Array.isArray(step.categories)
      ? step.categories
      : [];

  categories.forEach((category) => {
    initialAnswers[
      category.label
    ] = [];
  });

  setClassificationAnswers(
    initialAnswers
  );

  setIsAnswerChecked(false);
  setAnswerStatus(null);
  setDesableButton(true);
  setTextButton('Verifica');
  setChangeColorButton(false);
}

  const shuffledOptions = Array.isArray(step.options) ? shuffleArray(step.options) : [];
  setShuffledDecisionOptions(shuffledOptions);

  const normalizedDragOptions = Array.isArray(step.options)
    ? step.options.map((value, index) => ({
        id: buildDecisionOptionId(index),
        value,
        label: String(value),
      }))
    : [];

  const slotsCount = getDecisionDragSlotsCount(step);
  const initialDragAnswer = Array(slotsCount).fill(null);
  const fixedSlotIds = new Set();

  // Sempre aplica prefilledSlots, indiferent de optionType
  if (Array.isArray(step.prefilledSlots)) {
    step.prefilledSlots.forEach((fixedValue, slotIndex) => {
      if (slotIndex < 0 || slotIndex >= slotsCount) return;
      if (fixedValue === null || fixedValue === undefined || fixedValue === '') return;

      const match = normalizedDragOptions.find((option) => {
        return String(option.value).trim() === String(fixedValue).trim() && !fixedSlotIds.has(option.id);
      });

      if (match) {
        initialDragAnswer[slotIndex] = match.id;
        fixedSlotIds.add(match.id);
      } else {
        initialDragAnswer[slotIndex] = fixedValue;
      }
    });
  }

  setShuffledDecisionDragOptions(shuffleArray(
    normalizedDragOptions.filter((option) => !fixedSlotIds.has(option.id))
  ));
  setDecisionDragAnswer(initialDragAnswer);
  setSelectedDecisionDragOptionId(null);
}, [lessonData, nextQuestion, decisionStepIndex]);

useEffect(() => {
  const q =
    lessonData?.questions?.[
      nextQuestion
    ];

  if (!q) {
    return;
  }

  if (
    q.type ===
    'decisionFlowApplication'
  ) {
    setDecisionPhase('intro');
    setDecisionStepIndex(0);
    setDecisionAnswer(null);
    setDecisionSelectedAnswers([]);
    setDecisionDragAnswer([]);
  }

  const isClassificationOption =
    q.type ===
      'classificationOption' ||
    (
      q.type ===
        'simpleApplication' &&
      q.applicationType ===
        'classificationOption'
    );

  if (isClassificationOption) {
    const initialAnswers = {};

    const categories =
      Array.isArray(q.categories)
        ? q.categories
        : [];

    categories.forEach(
      (category) => {
        initialAnswers[
          category.label
        ] = [];
      }
    );

    setClassificationAnswers(
      initialAnswers
    );

    setIsAnswerChecked(false);
    setAnswerStatus(null);
    setDesableButton(true);
    setTextButton('Verifica');
    setChangeColorButton(false);
    setHideActionButton(false);
  }

  if (
    q.type ===
      'generalOptionDrag' ||
    q.type ===
      'orderSelectionDrag' ||
    q.type ===
      'activPasivOptionDrag'
  ) {
    const normalizedOptions =
      Array.isArray(q.options)
        ? q.options.map(
            (value, index) => ({
              id: buildGeneralOptionId(
                index
              ),
              value,
              label: String(value),
            })
          )
        : [];

    const shuffled =
      shuffleArray(
        normalizedOptions
      );

    setShuffledGeneralDragOptions(
      shuffled
    );

    if (
      q.type ===
      'orderSelectionDrag'
    ) {
      setGeneralDragAnswer(
        shuffled.map(
          (option) => option.id
        )
      );

      setDesableButton(false);
      setTextButton('Verifica');
      setChangeColorButton(true);
      setOrderSelectedSlotIndex(null);
    } else {
      const slotsCount =
        getDecisionDragSlotsCount(q);

      setGeneralDragAnswer(
        Array(slotsCount).fill(null)
      );
    }

    setSelectedDecisionDragOptionId(
      null
    );
  }
}, [
  nextQuestion,
  lessonData,
]);


// 🔥 Resetăm viețile DOAR la începutul lecției, NU la fiecare update
useEffect(() => {
  if (nextQuestion === 0) {
    setLives(3);

    // 🔁 reset statistici pe lecție
    setLessonCoins(0);
    setLessonXp(0);
    setCorrectAnswersCount(0);
    setWrongAnswersCount(0);
  }
}, [nextQuestion]);

const isJumpHereLesson =
  (lessonDataFromState?.explanationType || lessonData?.explanationType || '')
    .toLowerCase() === 'jumphere';

useEffect(() => {
  if (isJumpHereLesson) {
    setShowJumpHereIntro(true);
    return;
  }

  setShowJumpHereIntro(false);
}, [isJumpHereLesson, chapterId, lessonId]);





useEffect(() => {
  const question = lessonData?.questions?.[nextQuestion];

  if (question?.type === 'dragAndDropHorizontal') {
    const slotsCount = getHorizontalDragSlotsCount(question);
    setDataReceived(Array(slotsCount).fill(null));
  }
}, [lessonData, nextQuestion]);








useEffect(() => {
  if (lives <= 0) {
    setShowNoLivesPopup(true);
  }
}, [lives]);



useEffect(() => {
  let isMounted = true;

  const fetchUserStats = async () => {
    try {
      const userRes = await fetch(`${apiUrl}/user`, {
        credentials: "include",
      });

      if (!userRes.ok) return;

      const user = await userRes.json();
      const resolvedUserId = user?.user_id || userId;

      if (!resolvedUserId) return;

      const statsRes = await fetch(`${apiUrl}/user/${resolvedUserId}/stats`, {
        method: "GET",
        credentials: "include",
      });

      if (!statsRes.ok) return;

      const stats = await statsRes.json();

      if (!isMounted) return;

      setCoinCount(Number(stats?.coins ?? 0));
      setXp(Number(stats?.xp ?? 0));
    } catch (err) {
      console.error("Eroare la preluarea user_stats:", err);
    }
  };

  fetchUserStats();

  return () => {
    isMounted = false;
  };
}, [userId]);


const addXp = async (amount) => {
  const normalizedAmount = Number(amount || 0);
  let optimisticXp = null;

  setXp((prevXp) => {
    optimisticXp = Number(prevXp || 0) + normalizedAmount;
    return optimisticXp;
  });

  try {
    const res = await fetch(`${apiUrl}/stats/add-xp`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ xp: normalizedAmount }),
    });

    if (!res.ok) throw new Error("Eroare la adăugarea XP");

    const data = await res.json();
    const nextXp = Number(data?.xp);

    if (Number.isFinite(nextXp)) {
      setXp(nextXp);
      return nextXp;
    }

    return optimisticXp;
  } catch (err) {
    console.error("Eroare update XP:", err);
    return optimisticXp;
  }
};


const addCoins = async (amount) => {
  try {
    const res = await fetch(`${apiUrl}/stats/add-coins`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ coins: amount }),
    });

    if (!res.ok) {
      throw new Error("Eroare la actualizarea monedelor");
    }

    const data = await res.json();

    const nextCoins = Number(data?.coins);

    if (Number.isFinite(nextCoins)) {
      setCoinCount(nextCoins);
      return nextCoins;
    }

    return null;

  } catch (err) {
    console.error("Eroare update coins:", err);
    return null;
  }
};


const updateDailyMissions = async ({ xp = 0, lesson = 0, application = 0, coins = 0 }) => {
  try {
    await fetch(`${apiUrl}/missions/update`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        xp,
        lesson,
        application,
        coins
      })
    });
  } catch (err) {
    console.error("Eroare update misiuni:", err);
  }
};


const sendLessonFinishXp = async (amount) => {
  try {
    const res = await fetch(`${apiUrl}/stats/lesson-finished`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ xp: amount }),
    });

    const data = await res.json();
    setXp(data.xp);
  } catch (err) {
    console.error("Eroare la trimiterea XP final:", err);
  }
};



const grantXpForCorrectAnswer = () => {
  setCorrectStreak(prev => {
    const next = prev + 1;

    if (next === 5) {
      addXp(20);
      setLessonXp(prevXp => prevXp + 20);

      updateDailyMissions({ xp: 20 }); // 🔥 adaugă asta
    } else {
      addXp(10);
      setLessonXp(prevXp => prevXp + 10);

      updateDailyMissions({ xp: 10 }); // 🔥 adaugă asta
    }

  

    return next;
  });
};


const handleXpResetOnWrongAnswer = () => {
  setCorrectStreak(0);
  setWrongAnswersCount(prev => prev + 1);
};


const handleCorrectCoins = () => {
  if (isReplayLesson) {
    return;
  }

  setCoinCount(prev => prev + 1);
  setLessonCoins(prev => prev + 1);

  updateDailyMissions({ coins: 1 }); // 🔥 adaugă asta
};

const LIFE_PURCHASE_PRICE = 50;

const handleBuyLifeForCurrentLesson = async (livesToBuy = 1) => {
  const normalizedLivesToBuy = Math.min(3, Math.max(1, Number(livesToBuy) || 1));
  const totalPrice = LIFE_PURCHASE_PRICE * normalizedLivesToBuy;

  if (coinCount < totalPrice) {
    return false;
  }

  const updatedCoins = await addCoins(-totalPrice);

  if (updatedCoins === null || updatedCoins === undefined) {
    return false;
  }

  setLives((prev) => Math.max(0, prev) + normalizedLivesToBuy);
  return Number(updatedCoins);
};

const handleContinueAfterBuyingLife = () => {
  setShowNoLivesPopup(false);
};



useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (!currentQuestion) return;

  if (currentQuestion.type !== "lessonResume") {
    setShowRatingSection(false);
    return;
  }

  if (!currentQuestion.descriptionExplanation) return;

  // fiecare linie apare la 0.3s → totalul este:
  const delay = currentQuestion.descriptionExplanation.length * 300 + 400;

  const timer = setTimeout(() => {
    setShowRatingSection(true);
  }, delay);

  return () => clearTimeout(timer);
}, [lessonData, nextQuestion]);




useEffect(() => {
  if (showRatingSection) {
    const el = document.querySelector('.explanation-lesoon-container-resume-bc');

    if (el) {
      el.classList.add('no-scroll-transition');

      setTimeout(() => {
        el.classList.remove('no-scroll-transition');
      }, 600); // puțin peste durata animatiei
    }
  }
}, [showRatingSection]);




  useEffect(() => {
  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = '';
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, []);



const noTransitionTypes = [
  'lessonResume',
  'JustInTimeMotivation',
  'serieCompleta',
  'deblocarePremium',
  'clasament',
  'lessonCompletion',
  'giftlesson',
  'feedbackLesson',
];



useEffect(() => {
  document.documentElement.classList.add("quiz-active");
  document.body.classList.add("quiz-active");

  return () => {
    document.documentElement.classList.remove("quiz-active");
    document.body.classList.remove("quiz-active");
  };
}, []);



  const [hideActionButton, setHideActionButton] = useState(false);

const [showComments, setShowComments] = useState(false);



const [showExplanationPopupModal, setShowExplanationPopupModal] = useState(false);




const sendLessonCompletion = async (questionType, earnedXp = 0) => {
  if (questionType !== 'lessonCompletion' && questionType !== 'giftlesson') {
    return;
  }

  const normalizedChapterId = Number(chapterId);
  const normalizedLessonId = Number(lessonId);

  if (!Number.isFinite(normalizedChapterId) || !Number.isFinite(normalizedLessonId)) {
    console.error('❌ ID-uri invalide pentru lesson completion:', { chapterId, lessonId });
    return;
  }

  const normalizedEarnedXp = Math.max(0, Number(earnedXp) || 0);

  try {
    const response = await fetch(`${apiUrl}/lesson/complete`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        chapterId: normalizedChapterId,
        lessonId: normalizedLessonId,
        earnedXp: normalizedEarnedXp
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}`);
    }

    console.log("✅ Lesson completion trimisa");
    trackQuizFinish(quizAttemptRef.current, { chapterId: normalizedChapterId, lessonId: normalizedLessonId, course: 'bazele' });
  } catch (err) {
    console.error("❌ Eroare lesson completion:", err);
  }
};


  
  
  const [showFeedback, setShowFeedback] = useState(false);

const handleShowFeedback = () => setShowFeedback(true);
const handleHideFeedback = () => setShowFeedback(false);


  const explanationRef = useRef(null);




const updateCoins = (newAmount) => {
  fetch(`${apiUrl}/user/${userId}/stats`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      coins: newAmount
    })
  })
  .catch(err => console.log("Error updating coins:", err));
};








  const [showExplanationPopup, setShowExplanationPopup] = useState(false);




  const [showEyePopup, setShowEyePopup] = useState(false);

const handleShowEyePopup = () => {
  setShowEyePopup(true);
};

const closeEyePopup = () => {
  setShowEyePopup(false);
};



const [showAlert, setShowAlert] = useState(false);


const handleExitClick = () => {
  setShowAlert(true);
};

const handleConfirmExit = () => {
  setShowAlert(false);
  navigate('/functionalpagelogin'); // Redirecționează către pagina /functionalpagelogin
};

const handleCancelExit = () => {
  setShowAlert(false);
};

const messageAlertClose = 
<div>
  <h3>Nu renunța!</h3>
  <p>Dacă părăsești această lecție, vei pierde progresul. Ești sigur?</p>
</div>;








  const currentType = lessonData?.questions?.[nextQuestion]?.type;




  const [isLessonFinished, setIsLessonFinished] = useState(false); // Stare pentru finalizarea lecției


  const [changeColorButton, setChangeColorButton] = useState(false);




  //stateuri pentru raspunsul corect

  const [simpleCorrectAnswer, setSimpleCorrectAnswer] = useState(false)


const lessonCompletionSentRef = useRef(false);



  // Funcția pentru a finaliza lecția și redirecționare

  
  const finalizeLesson = () => {

    const lessonProgress = JSON.parse(localStorage.getItem('lessonProgress')) || {};
    const normalizedChapterId = Number(chapterId);
    const normalizedLessonId = Number(lessonId);
    const currentLessonKey = `${normalizedChapterId}-${normalizedLessonId}`;

    const updatedProgress = {
      [currentLessonKey]: {
        ...(lessonProgress[currentLessonKey] || {}),
        completed: true,
        unlocked: true,
      },
    };

    // Salvează progresul actualizat în localStorage
    localStorage.setItem(
      'lessonProgress',
      JSON.stringify({
        ...lessonProgress,
        ...updatedProgress,
      })
    );
    addXp(20);


    // Navighează înapoi la Showlessons și trimite progresul prin state
    navigate('/functionalpagelogin', { state: { updatedProgress } });
 // Redirecționează la LessonContainer
  };

  

//functia pentru calcularea progresului

const calculateProgress = () => {
  const questions =
    Array.isArray(lessonData?.questions)
      ? lessonData.questions
      : [];

  if (questions.length === 0) {
    return 0;
  }

  const getQuestionUnits = (question) => {
    if (
      !question ||
      ignoredForProgress.includes(
        question.type
      )
    ) {
      return 0;
    }

    if (
      question.type ===
      'decisionFlowApplication'
    ) {
      const steps =
        Array.isArray(question.steps)
          ? question.steps
          : [];

      /*
       * Fiecare pas reprezinta un quiz
       * separat in bara principala.
       */
      return Math.max(
        steps.length,
        1
      );
    }

    /*
     * Orice alt quiz valoreaza o unitate.
     */
    return 1;
  };

  const totalUnits =
    questions.reduce(
      (total, question) =>
        total +
        getQuestionUnits(question),
      0
    );

  if (totalUnits === 0) {
    return 0;
  }

  /*
   * Adunam toate unitatile intrebarilor
   * finalizate anterior.
   */
  const completedBeforeCurrent =
    questions
      .slice(0, nextQuestion)
      .reduce(
        (total, question) =>
          total +
          getQuestionUnits(question),
        0
      );

  const currentQuestion =
    questions[nextQuestion];

  let completedCurrent = 0;

  if (
    currentQuestion &&
    !ignoredForProgress.includes(
      currentQuestion.type
    )
  ) {
    if (
      currentQuestion.type ===
      'decisionFlowApplication'
    ) {
      const steps =
        Array.isArray(
          currentQuestion.steps
        )
          ? currentQuestion.steps
          : [];

      const totalDecisionSteps =
        Math.max(
          steps.length,
          1
        );

      if (
        decisionPhase === 'final'
      ) {
        /*
         * Toate etapele aplicatiei sunt
         * finalizate.
         */
        completedCurrent =
          totalDecisionSteps;
      } else if (
        decisionPhase === 'steps'
      ) {
        /*
         * decisionStepIndex reprezinta
         * pasii anteriori deja terminati.
         *
         * Dupa verificarea pasului curent,
         * mai adaugam o unitate.
         */
        completedCurrent =
          decisionStepIndex +
          (isAnswerChecked ? 1 : 0);

        completedCurrent = Math.min(
          completedCurrent,
          totalDecisionSteps
        );
      }
    } else if (isAnswerChecked) {
      /*
       * Quiz obisnuit verificat.
       */
      completedCurrent = 1;
    }
  }

  const completedUnits =
    completedBeforeCurrent +
    completedCurrent;

  const progress =
    (completedUnits / totalUnits) *
    100;

  return Math.min(
    Math.max(progress, 0),
    100
  );
};








  //state pentru setarea mesajului

    // State pentru a stoca răspunsurile mutate
    const [dataReceived, setDataReceived] = useState([]);
    const [isTopProgressReady, setIsTopProgressReady] = useState(true);
    const [pendingLessonCompletionAdvance, setPendingLessonCompletionAdvance] = useState(false);
    const [shouldDelayLessonCompletionAdvance, setShouldDelayLessonCompletionAdvance] = useState(false);
    const lessonCompletionDelayTimeoutRef = useRef(null);

 


     
 


const advanceQuestion = () => {
  resetQuestionState();

  setDecisionPhase('intro');
  setDecisionStepIndex(0);
setAssociationAnswers({});
  setDecisionAnswer(null);
  setDecisionSelectedAnswers([]);
  setDecisionDragAnswer([]);

  setDesableButton(false);
  setTextButton('Continua');
  setChangeColorButton(false);

  setNextQuestion((prev) => {
    const newNextQuestion = prev + 1;

    if (newNextQuestion >= lessonData.questions.length) {
      setIsLessonFinished(true);
      return prev;
    }

    return newNextQuestion;
  });
};

const toNextQuestion = () => {
  if (pendingLessonCompletionAdvance) {
    return;
  }

  if (!noTransitionTypes.includes(currentType) && !isTopProgressReady) {
    return;
  }

  const nextQuestionType = lessonData?.questions?.[nextQuestion + 1]?.type;
  const shouldWaitForCompletionBar =
    nextQuestionType === 'lessonCompletion' ||
    nextQuestionType === 'giftlesson';

  if (shouldWaitForCompletionBar && !pendingLessonCompletionAdvance) {
    setIsTopProgressReady(true);
    setShouldDelayLessonCompletionAdvance(false);
    setPendingLessonCompletionAdvance(false);
    advanceQuestion();
    return;
  }

  advanceQuestion();
};

useEffect(() => {
  if (!pendingLessonCompletionAdvance || !isTopProgressReady) {
    return;
  }

  if (shouldDelayLessonCompletionAdvance) {
    if (lessonCompletionDelayTimeoutRef.current) {
      clearTimeout(lessonCompletionDelayTimeoutRef.current);
    }

    lessonCompletionDelayTimeoutRef.current = setTimeout(() => {
      setPendingLessonCompletionAdvance(false);
      setShouldDelayLessonCompletionAdvance(false);
      advanceQuestion();
      lessonCompletionDelayTimeoutRef.current = null;
    }, 0);

    return;
  }

  setPendingLessonCompletionAdvance(false);
  setShouldDelayLessonCompletionAdvance(false);
  advanceQuestion();
}, [pendingLessonCompletionAdvance, isTopProgressReady, shouldDelayLessonCompletionAdvance]);

useEffect(() => {
  if (!pendingLessonCompletionAdvance || isTopProgressReady) {
    return;
  }

  const fallbackTimer = setTimeout(() => {
    setIsTopProgressReady(true);
  }, 700);

  return () => clearTimeout(fallbackTimer);
}, [pendingLessonCompletionAdvance, isTopProgressReady]);

useEffect(() => {
  return () => {
    if (lessonCompletionDelayTimeoutRef.current) {
      clearTimeout(lessonCompletionDelayTimeoutRef.current);
    }
  };
}, []);




useEffect(() => {
  if (!lessonData) return;

  const question = lessonData.questions[nextQuestion];

  if (!question) return;

  // 🔥 reset total pentru drag & drop
  if (question.type === 'dragAndDropHorizontal') {
    const slotsCount = getHorizontalDragSlotsCount(question);
    setDataReceived(Array(slotsCount).fill(null));
  }



  if (question.type === 'optionDragAndDropFormulaLeft') {
    const slotsCount = Array.isArray(question.correctAnswer) && question.correctAnswer.length > 0
      ? question.correctAnswer.length
      : 8;
    setDataReceived(Array(slotsCount).fill(null));
  }

  if (question.type === 'optionDragAndDropFormulaRight') {
    const slotsCount = Array.isArray(question.correctAnswer) && question.correctAnswer.length > 0
      ? question.correctAnswer.length
      : 8;
    setDataReceived(Array(slotsCount).fill(null));
  }
}, [nextQuestion, lessonData]);



useEffect(() => {
  if (explanationRef.current) {
    explanationRef.current.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    // fallback pentru tot documentul dacă nu ai explanationRef în pagină
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}, [nextQuestion]);




  useEffect(() => {
    if (chapterId && lessonId) {
      // Cererea fetch pentru lecția selectată
      fetch(`${apiUrl}/chapter/${chapterId}/lesson/${lessonId}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache"
        }
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('A apărut o eroare');
        }
        return response.json();
      })
      .then(data => {
        setLessonData(data);
      })
      .catch(err => {
        console.error(`Error: ${err}`);
      });
    }
  }, [chapterId, lessonId]);


// Folosim un string (sau null) pentru simpleSelectType, deoarece utilizatorul selectează o singură opțiune
const [simpleSelectType, setSimpleSelectType] = useState(null); //usestateul pentru stocarea raspusurilor simple select
const [userInput, setUserInput] = useState({});  // Răspunsul introdus de utilizator
const [selectedAnswers, setSelectedAnswers] = useState([]); // Răspunsurile bifate de utilizator


const handleMultipleAnswerToggle = useCallback((option) => {
  setSelectedAnswers((previousAnswers) => {
    const updatedAnswers = previousAnswers.includes(option)
      ? previousAnswers.filter((answer) => answer !== option)
      : [...previousAnswers, option];

    setDesableButton(updatedAnswers.length === 0);

    if (updatedAnswers.length > 0) {
      setTextButton('Verifica');
      setChangeColorButton(true);
    }

    return updatedAnswers;
  });
}, []);


const [message, setMessage] = useState('');
const [textButton, setTextButton] = useState('')



const [isAnswerChecked, setIsAnswerChecked] = useState(false); //urmaresc daca raspunsul a fost verificat


const handleAssociationComplete =
  useCallback(() => {
    if (isAnswerChecked) {
      return;
    }

    setIsAnswerChecked(true);
    setAnswerStatus('correct');

    /*
     * Afiseaza FeedbackPopup direct.
     */
    setShowFeedback(true);

    /*
     * Ascunde bara normala.
     */
    setHideActionButton(true);

    setDesableButton(false);
    setTextButton('Continua');
    setChangeColorButton(false);

    playSoundEffect(levelUp);
    handleCorrectCoins();
    grantXpForCorrectAnswer();
    triggerVibration(200);
  }, [
    isAnswerChecked,
    playSoundEffect,
    handleCorrectCoins,
    grantXpForCorrectAnswer,
  ]);




const handleSingleAnswerSelect = useCallback((option) => {
  setSimpleSelectType(option);
  setDesableButton(false);
  setTextButton('Verifica');
  setChangeColorButton(true);
}, []);

const buttonTextChange = () => {

  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return <p>Loading lesson...</p>;
  }
  const currentQuestion = lessonData.questions[nextQuestion]; 

  switch (currentQuestion.type) {
 

    case 'simpleSelect':
      setTextButton('Verifica')
      setChangeColorButton(true)
      break;

    case 'manualInput':
      
      break;

 

      case 'dragAndDropHorizontal':
        setTextButton('Verifica');
       
        
        break;

  

        case 'orderSelectionDrag':
        case 'generalOptionDrag':
        case 'activPasivOptionDrag':
          setTextButton('Verifica');
          break;


    case 'multipleSelect':
      setTextButton('Verifica')
     
      break;

    case 'formulaExplanationLesson':
      setTextButton('Continua00000');
      break;

    default:
      
  }
};


const [desableButon, setDesableButton] = useState(false);
//functia pentru dezactivarea butonului



useEffect(() => {
  const currentQuestion =
    lessonData?.questions?.[nextQuestion];

  if (
    currentQuestion?.type ===
    'feedbackLesson'
  ) {
    setHasLessonFeedback(false);
    setDesableButton(true);
    setTextButton('Continua');
    setChangeColorButton(false);
  }
}, [lessonData, nextQuestion]);


useEffect(() => {
  if (
    !lessonData ||
    !lessonData.questions ||
    lessonData.questions.length === 0
  ) {
    return;
  }

  const currentQuestion =
    lessonData.questions[nextQuestion];

  /*
   * Decision flow are propria logica pentru
   * activarea butonului la fiecare pas.
   */
  if (
    currentQuestion.type ===
    'decisionFlowApplication'
  ) {
    return;
  }

  // Resetare stari pentru fiecare noua intrebare
  setIsAnswerChecked(false);
  setSimpleSelectType(null);
  setMessage('');
  setSimpleCorrectAnswer(false);

  if (
    [
      'simpleSelect',
      'manualInput',
      'dragAndDropHorizontal',
      'formulaDragAndDrop',
      'multipleSelect',
      'generalOptionDrag',
      'activPasivOptionDrag',
      'trueFalseQuiz',
      'classificationOption',
      'associationOption',
    ].includes(currentQuestion.type)
  ) {
    setDesableButton(true);
  } else {
    setDesableButton(false);
  }
}, [
  nextQuestion,
  lessonData,
]);

const [answerStatus, setAnswerStatus] = useState(null); // Starea pentru corect/greșit/null


const resetQuestionState = () => {
  setClassificationAnswers({});
  setAssociationAnswers({});
  setSelectedAnswers([]);
  setSimpleSelectType(null);
  setUserInput({});
  setFormulaDragAnswers({});
setShuffledFormulaDragOptions([]);
  setIsAnswerChecked(false);
  setSimpleCorrectAnswer(false);
  setAnswerStatus(null);
  setMessage('');
  setTextButton('');
  setChangeColorButton(false);
  setDesableButton(true);
  setShowCorrectAnswer(false);
  
};












// Adăugăm o stare pentru a controla afișarea răspunsului corect
const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);




  // Selecteaza automat raspunsul corect si marcheaza intrebarea ca verificata (folosit de PopupQuestion)
  const handleRevealAnswer = () => {
    if (!lessonData || !lessonData.questions) return;

    const baseQuestion = lessonData.questions[nextQuestion];
    if (!baseQuestion) return;

    const isDecisionFlow = baseQuestion.type === 'decisionFlowApplication';
    const q = isDecisionFlow ? baseQuestion.steps?.[decisionStepIndex] : baseQuestion;
    if (!q) return;

    const fillDecisionDragAnswer = (step) => {
      const slotsCount = getDecisionDragSlotsCount(step);
      const expectedAnswers = Array.isArray(step.correctAnswer) ? step.correctAnswer : [];
      const next = Array(slotsCount).fill(null);

      expectedAnswers.forEach((expectedValue, slotIndex) => {
        if (slotIndex >= slotsCount) return;
        if (expectedValue === null || expectedValue === undefined || expectedValue === '') return;

        const optionIndex = Array.isArray(step.options)
          ? step.options.findIndex((option) => String(getDecisionOptionValueById(step, buildDecisionOptionId(step.options.indexOf(option)))) === String(expectedValue))
          : -1;

        next[slotIndex] = optionIndex !== -1
          ? buildDecisionOptionId(optionIndex)
          : expectedValue;
      });

      setDecisionDragAnswer(next);
    };

    if (isDecisionFlow) {
      const optionType =
        q.optionType ||
        q.stepType ||
        (typeof q.type === 'string' && q.type.startsWith('option') ? q.type : 'simpleOption');
      const isMultiple = optionType === 'multipleOption';
      const isDragLayout =
        optionType === 'optionDragAndDrop' ||
        optionType === 'optionDragAndDropFormula' ||
        optionType === 'optionDragAndDropFormulaLeft' ||
        optionType === 'optionDragAndDropFormulaRight' ||
        optionType === 'optionDragTaccount';

      if (isDragLayout) {
        fillDecisionDragAnswer(q);
      } else if (isMultiple) {
        setDecisionSelectedAnswers(Array.isArray(q.correctAnswer) ? [...q.correctAnswer] : []);
      } else {
        setDecisionAnswer(q.correctAnswer ?? null);
      }

      setIsAnswerChecked(true);
      setAnswerStatus('correct');
      setDesableButton(false);
      setChangeColorButton(false);
      setTextButton('Continua');
      handleCorrectCoins();
      grantXpForCorrectAnswer();
      playSoundEffect(levelUp);
      triggerVibration(200);
      return;
    }

    switch (q.type) {
      case 'simpleSelect':
      case 'trueFalseQuiz':
      case 'cresteScadeQuiz':
      case 'simpleApplication':
        setSimpleSelectType(q.correctAnswer);
        break;
      case 'multipleSelect':
        setSelectedAnswers(Array.isArray(q.correctAnswer) ? [...q.correctAnswer] : []);
        break;
      case 'generalOptionDrag':
      case 'activPasivOptionDrag':
      case 'orderSelectionDrag': {
        const correct = Array.isArray(q.correctAnswer) ? q.correctAnswer : [];
        const ids = correct.map(val => {
          const opt = shuffledGeneralDragOptions.find(o => String(o.value) === String(val));
          return opt ? opt.id : null;
        });
        setGeneralDragAnswer(ids);
        break;
      }
  
      case 'dragAndDropHorizontal': {
        const expected = getHorizontalDragExpectedAnswers(q).map((item) => String(item));
        const ids = expected.map(val => {
          if (!Array.isArray(q?.options)) return null;
          const index = q.options.findIndex(opt => String(getHorizontalOptionValue(opt)) === val);
          return index !== -1 ? `horizontal-opt-${index}` : null;
        });
        setDataReceived(ids);
        break;
      }

      case 'formulaDragAndDrop': {
  const expectedAnswers =
    q.correctAnswer &&
    typeof q.correctAnswer ===
      'object' &&
    !Array.isArray(
      q.correctAnswer
    )
      ? q.correctAnswer
      : {};

  const usedOptionIds =
    new Set();

  const revealedAnswers =
    Object.entries(
      expectedAnswers
    ).reduce(
      (
        result,
        [slotId, expectedValue]
      ) => {
        const matchingOption =
          shuffledFormulaDragOptions.find(
            (option) =>
              !usedOptionIds.has(
                option.id
              ) &&
              String(option.value) ===
                String(expectedValue)
          );

        if (matchingOption) {
          result[slotId] =
            matchingOption.id;

          usedOptionIds.add(
            matchingOption.id
          );
        } else {
          result[slotId] = null;
        }

        return result;
      },
      {}
    );

  setFormulaDragAnswers(
    revealedAnswers
  );

  break;
}


      default:
        break;
    }

    // Marchează ca corect și dă recompense
    setIsAnswerChecked(true);
    setAnswerStatus('correct');
    setDesableButton(false);
    setChangeColorButton(false);
    setTextButton('Continua');

    // Dă bani și XP pentru răspunsul corect
    handleCorrectCoins();
    grantXpForCorrectAnswer();

    // Joacă sunet și vibrație
    playSoundEffect(levelUp);
    triggerVibration(200);
  };

  //functia de verificare a raspunsurilor
  
  const verifyAnswer = () => {

       if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
      return <p>Loading lesson...</p>;
    }
    const currentQuestion = lessonData.questions[nextQuestion]; 


    switch (currentQuestion.type) {
 

      case 'trueFalseQuiz':
      case 'cresteScadeQuiz':
          if (!isAnswerChecked) {
              if (currentQuestion.correctAnswer === simpleSelectType) {
                  setAnswerStatus('correct');
                  playSoundEffect(levelUp);
                  handleCorrectCoins();
                  grantXpForCorrectAnswer();
                  triggerVibration(200);
              } else {
                  setAnswerStatus('incorrect');
                  setLives(prev => prev - 1);
                  handleXpResetOnWrongAnswer();
                  playSoundEffect(error);
                  setSimpleCorrectAnswer(currentQuestion.correctAnswer);
                  triggerVibration([300, 100, 300]);
              }
              setIsAnswerChecked(true);
              setDesableButton(false);
              setChangeColorButton(false);
          } else {
              setIsAnswerChecked(false);
              setSimpleSelectType(null);
              setMessage('');
              toNextQuestion();
              setShowCorrectAnswer(false);
          }
          break;


case 'associationOption':
  if (!isAnswerChecked) {
    const correctAnswer =
      currentQuestion.correctAnswer &&
      typeof currentQuestion.correctAnswer ===
        'object'
        ? currentQuestion.correctAnswer
        : {};

    const leftOptions =
      Array.isArray(
        currentQuestion.leftOptions
      )
        ? currentQuestion.leftOptions
        : [];

 const allCorrect =
  leftOptions.length > 0 &&
  Object.keys(
    associationAnswers
  ).length === leftOptions.length &&
  leftOptions.every(
    (leftOption) =>
      String(
        associationAnswers[
          leftOption
        ] ?? ''
      )
        .trim()
        .toLowerCase() ===
      String(
        correctAnswer[
          leftOption
        ] ?? ''
      )
        .trim()
        .toLowerCase()
  );

    if (allCorrect) {
      setAnswerStatus(
        'correct'
      );

      playSoundEffect(
        levelUp
      );

      handleCorrectCoins();
      grantXpForCorrectAnswer();
      triggerVibration(200);
    } else {
      setAnswerStatus(
        'incorrect'
      );

      setLives(
        (prev) => prev - 1
      );

      handleXpResetOnWrongAnswer();

      playSoundEffect(
        error
      );

      triggerVibration([
        300,
        100,
        300,
      ]);
    }

    setIsAnswerChecked(true);
    setDesableButton(false);
    setChangeColorButton(false);
    setTextButton('Continua');
  } else {
    setIsAnswerChecked(false);
    setAssociationAnswers({});
    toNextQuestion();
  }

  break;


      case 'simpleSelect':
          if (!isAnswerChecked) {
              setDesableButton(true); // Dezactivați butonul la începutul întrebării
              if (currentQuestion.correctAnswer === simpleSelectType) {
                setMessage(''); // Folosește numele real al array-ului

                  setAnswerStatus('correct');
                  playSoundEffect(levelUp);
                  handleCorrectCoins();

                 // -------- XP ----------
                 grantXpForCorrectAnswer();



                  triggerVibration(200);
                  setDesableButton(false); // Activează butonul după verificarea răspunsului
              } else {
                  setMessage(''); 
                  setAnswerStatus('incorrect');
                  // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





                  playSoundEffect(error);
                  setSimpleCorrectAnswer(currentQuestion.correctAnswer);
                  triggerVibration([300, 100, 300]);
                  setDesableButton(false);
              }
              setIsAnswerChecked(true);
             
              setShowCorrectAnswer(false);
              setChangeColorButton(false);
          } else {
              // Trecem la următoarea întrebare
              setIsAnswerChecked(false);
              setSimpleSelectType(null);
              setMessage('');
              
              toNextQuestion();
              setShowCorrectAnswer(false);
          }
          break;
      case 'manualInput':
        if (!isAnswerChecked) {
          // Verificăm dacă toate răspunsurile sunt corecte
          let allCorrect = true;
          currentQuestion.correctAnswer.forEach((answer, index) => {
            // Comparam răspunsul utilizatorului cu codul corect
            if (Number(userInput[index]) !== answer.code) {
              allCorrect = false;
            }
          });
          if (allCorrect) {
           setMessage('');
            setAnswerStatus('correct');
            playSoundEffect(levelUp);
            setSimpleCorrectAnswer(false);
            handleCorrectCoins();

             grantXpForCorrectAnswer();


            // Vibrație scurtă pentru răspuns corect
          triggerVibration(200); // 200ms pentru un răspuns corect
          } else {
            setMessage('');

            setAnswerStatus('incorrect');
            // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





            playSoundEffect(error);
            setSimpleCorrectAnswer(currentQuestion.correctAnswer.map((newAnswer) => {
             return <div>{newAnswer.code}:{newAnswer.label}</div>
            }));
            triggerVibration([300, 100, 300]);
          }
          setIsAnswerChecked(true);  // Marchez răspunsul ca verificat
          setChangeColorButton(false)
          setDesableButton(false); // Activăm butonul după verificare pentru a permite utilizatorului să continue
        } else {
          // A doua fază: Trecem la următoarea întrebare
          setIsAnswerChecked(false);  // Resetează starea de verificare
          setUserInput({});  // Resetează input-urile utilizatorului
          setMessage('');  // Resetează mesajul
          setChangeColorButton(false);
          toNextQuestion();  // Trecem la următoarea întrebare
        }
        break;
   


        case 'formulaDragAndDrop':
  if (!isAnswerChecked) {
    const expectedAnswers =
      currentQuestion.correctAnswer &&
      typeof currentQuestion.correctAnswer ===
        'object' &&
      !Array.isArray(
        currentQuestion.correctAnswer
      )
        ? currentQuestion.correctAnswer
        : {};

    const optionValueById =
      shuffledFormulaDragOptions.reduce(
        (result, option) => {
          result[option.id] =
            option.value;

          return result;
        },
        {}
      );

    const isCorrect =
      Object.entries(
        expectedAnswers
      ).every(
        ([
          slotId,
          expectedValue,
        ]) => {
          const selectedOptionId =
            formulaDragAnswers[
              slotId
            ];

          const selectedValue =
            optionValueById[
              selectedOptionId
            ];

          return (
            String(selectedValue) ===
            String(expectedValue)
          );
        }
      );

    if (isCorrect) {
      setAnswerStatus('correct');
      playSoundEffect(levelUp);
      handleCorrectCoins();
      grantXpForCorrectAnswer();
      triggerVibration(200);
    } else {
      setAnswerStatus('incorrect');
      setLives(
        (prev) => prev - 1
      );
      handleXpResetOnWrongAnswer();
      playSoundEffect(error);
      triggerVibration([
        300,
        100,
        300,
      ]);
    }

    setIsAnswerChecked(true);
    setDesableButton(false);
    setChangeColorButton(false);
    setTextButton('Continua');
  } else {
    setIsAnswerChecked(false);
    setFormulaDragAnswers({});
    setMessage('');
    toNextQuestion();
    setShowCorrectAnswer(false);
  }

  break;


case 'simpleApplication': {
  if (!isAnswerChecked) {
    const applicationType =
      currentQuestion.applicationType ||
      'simpleSelect';

    const normalizeValue = (value) =>
      String(value ?? '')
        .trim()
        .toLowerCase();

    const sortValues = (values) =>
      values
        .map(normalizeValue)
        .sort();

    let isCorrect = false;

    if (
      applicationType ===
      'simpleSelect'
    ) {
      isCorrect =
        normalizeValue(
          simpleSelectType
        ) ===
        normalizeValue(
          currentQuestion.correctAnswer
        );
    }

    if (
      applicationType ===
      'multipleSelect'
    ) {
      const expectedAnswers =
        Array.isArray(
          currentQuestion.correctAnswer
        )
          ? currentQuestion.correctAnswer
          : [];

      isCorrect =
        JSON.stringify(
          sortValues(selectedAnswers)
        ) ===
        JSON.stringify(
          sortValues(expectedAnswers)
        );
    }

    if (
      applicationType ===
      'dragAndDropHorizontal'
    ) {
      const expectedAnswers =
        getHorizontalDragExpectedAnswers(
          currentQuestion
        ).map(String);

      const selectedValues =
        dataReceived.map(
          (optionId) =>
            getHorizontalOptionValueById(
              currentQuestion,
              optionId
            )
        );

      const allSlotsFilled =
        selectedValues.length ===
          expectedAnswers.length &&
        selectedValues.every(
          (value) =>
            value !== null &&
            value !== undefined &&
            value !== ''
        );

      isCorrect =
        allSlotsFilled &&
        selectedValues.every(
          (value, index) =>
            normalizeValue(value) ===
            normalizeValue(
              expectedAnswers[index]
            )
        );
    }

    if (
      applicationType ===
      'generalOptionDrag'
    ) {
      const expectedAnswers =
        Array.isArray(
          currentQuestion.correctAnswer
        )
          ? currentQuestion.correctAnswer
          : [];

      const selectedValues =
        generalDragAnswer.map(
          (optionId) =>
            getGeneralOptionValueById(
              currentQuestion,
              optionId
            )
        );

      const allSlotsFilled =
        selectedValues.length ===
          expectedAnswers.length &&
        selectedValues.every(
          (value) =>
            value !== null &&
            value !== undefined &&
            value !== ''
        );

      const answerMode =
        currentQuestion.answerMode ||
        'ordered';

      if (
        answerMode === 'unordered'
      ) {
        isCorrect =
          allSlotsFilled &&
          JSON.stringify(
            sortValues(selectedValues)
          ) ===
          JSON.stringify(
            sortValues(expectedAnswers)
          );
      } else if (
        answerMode ===
        'unorderedPerRow'
      ) {
        let startIndex = 0;

        isCorrect =
          allSlotsFilled &&
          Array.isArray(
            currentQuestion.rows
          ) &&
          currentQuestion.rows.every(
            (row) => {
              const rowSlots =
                Math.max(
                  0,
                  Number(
                    row?.slots
                  ) || 0
                );

              const endIndex =
                startIndex +
                rowSlots;

              const selectedRow =
                selectedValues.slice(
                  startIndex,
                  endIndex
                );

              const expectedRow =
                expectedAnswers.slice(
                  startIndex,
                  endIndex
                );

              startIndex =
                endIndex;

              return (
                JSON.stringify(
                  sortValues(
                    selectedRow
                  )
                ) ===
                JSON.stringify(
                  sortValues(
                    expectedRow
                  )
                )
              );
            }
          );
      } else {
        isCorrect =
          allSlotsFilled &&
          selectedValues.every(
            (value, index) =>
              normalizeValue(value) ===
              normalizeValue(
                expectedAnswers[index]
              )
          );
      }
    }

    if (
      applicationType ===
      'classificationOption'
    ) {
      const expectedAnswers =
        currentQuestion.correctAnswer &&
        typeof currentQuestion.correctAnswer ===
          'object' &&
        !Array.isArray(
          currentQuestion.correctAnswer
        )
          ? currentQuestion.correctAnswer
          : {};

      const categories =
        Array.isArray(
          currentQuestion.categories
        )
          ? currentQuestion.categories
          : [];

      isCorrect =
        categories.length > 0 &&
        categories.every(
          (category) => {
            const categoryLabel =
              category.label;

            const selectedCategory =
              Array.isArray(
                classificationAnswers[
                  categoryLabel
                ]
              )
                ? classificationAnswers[
                    categoryLabel
                  ]
                : [];

            const expectedCategory =
              Array.isArray(
                expectedAnswers[
                  categoryLabel
                ]
              )
                ? expectedAnswers[
                    categoryLabel
                  ]
                : [];

            return (
              JSON.stringify(
                sortValues(
                  selectedCategory
                )
              ) ===
              JSON.stringify(
                sortValues(
                  expectedCategory
                )
              )
            );
          }
        );
    }

    if (isCorrect) {
      setAnswerStatus('correct');
      playSoundEffect(levelUp);
      handleCorrectCoins();
      grantXpForCorrectAnswer();
      triggerVibration(200);
    } else {
      setAnswerStatus('incorrect');
      setLives(
        (prev) => prev - 1
      );
      handleXpResetOnWrongAnswer();
      playSoundEffect(error);
      setSimpleCorrectAnswer(
        currentQuestion.correctAnswer
      );
      triggerVibration(
        [300, 100, 300]
      );
    }

    setIsAnswerChecked(true);
    setDesableButton(false);
    setChangeColorButton(false);
  } else {
    setIsAnswerChecked(false);
    setSimpleSelectType(null);
    setSelectedAnswers([]);
    setDataReceived([]);
    setGeneralDragAnswer([]);
    setClassificationAnswers({});
    setMessage('');
    toNextQuestion();
  }

  break;
}

case 'decisionFlowApplication': {
  const step =
    currentQuestion.steps?.[
      decisionStepIndex
    ];

  if (!step) {
    break;
  }

  const optionType =
    step.type === 'formulaDragAndDrop'
      ? 'formulaDragAndDrop'
      : (
          step.optionType ||
          step.stepType ||
          (
            typeof step.type === 'string' &&
            step.type.startsWith('option')
              ? step.type
              : 'simpleOption'
          )
        );

  const isMultiple =
    optionType === 'multipleOption';

  const isClassification =
    optionType === 'classificationOption';

  const isFormulaDragAndDrop =
    optionType === 'formulaDragAndDrop';

  const isFormulaLayout =
    optionType ===
      'optionDragAndDropFormula' ||
    optionType ===
      'optionDragAndDropFormulaLeft' ||
    optionType ===
      'optionDragAndDropFormulaRight';

  const isTaccountLayout =
    optionType === 'optionDragTaccount';

  const isDragAndDrop =
    optionType ===
      'optionDragAndDrop' ||
    isFormulaLayout ||
    isTaccountLayout;

  let isCorrect = false;

  /*
   * =========================================
   * FORMULA DRAG AND DROP
   * =========================================
   */
  if (isFormulaDragAndDrop) {
    const expectedAnswers =
      step.correctAnswer &&
      typeof step.correctAnswer ===
        'object' &&
      !Array.isArray(
        step.correctAnswer
      )
        ? step.correctAnswer
        : {};

    /*
     * formulaDragAnswers pastreaza ID-ul
     * optiunii puse in fiecare slot.
     *
     * Cream un dictionar:
     * ID optiune -> valoarea reala.
     */
    const optionValueById =
      shuffledFormulaDragOptions.reduce(
        (result, option) => {
          result[option.id] =
            option.value;

          return result;
        },
        {}
      );

    const requiredSlotIds =
      Object.keys(
        expectedAnswers
      );

    const normalizeValue = (
      value
    ) =>
      String(value ?? '')
        .trim()
        .toLowerCase();

    const allSlotsFilled =
      requiredSlotIds.length > 0 &&
      requiredSlotIds.every(
        (slotId) => {
          const selectedOptionId =
            formulaDragAnswers[
              slotId
            ];

          return (
            selectedOptionId !==
              null &&
            selectedOptionId !==
              undefined &&
            selectedOptionId !== ''
          );
        }
      );

    isCorrect =
      allSlotsFilled &&
      requiredSlotIds.every(
        (slotId) => {
          const selectedOptionId =
            formulaDragAnswers[
              slotId
            ];

          /*
           * In unele situatii valoarea
           * poate veni deja direct,
           * nu neaparat ca ID.
           */
          const selectedValue =
            optionValueById[
              selectedOptionId
            ] ??
            selectedOptionId;

          const expectedValue =
            expectedAnswers[
              slotId
            ];

          return (
            normalizeValue(
              selectedValue
            ) ===
            normalizeValue(
              expectedValue
            )
          );
        }
      );
  }

  /*
   * =========================================
   * CLASSIFICATION OPTION
   * =========================================
   */
  else if (isClassification) {
    const expectedAnswers =
      step.correctAnswer &&
      typeof step.correctAnswer ===
        'object' &&
      !Array.isArray(
        step.correctAnswer
      )
        ? step.correctAnswer
        : {};

    const normalizeValue = (
      value
    ) =>
      String(value ?? '')
        .trim()
        .toLowerCase();

    const sortValues = (
      values
    ) =>
      [...values]
        .map(
          normalizeValue
        )
        .sort();

    const categories =
      Array.isArray(
        step.categories
      )
        ? step.categories
        : [];

    isCorrect =
      categories.length > 0 &&
      categories.every(
        (category) => {
          const categoryLabel =
            category.label;

          const selectedCategory =
            Array.isArray(
              classificationAnswers[
                categoryLabel
              ]
            )
              ? classificationAnswers[
                  categoryLabel
                ]
              : [];

          const expectedCategory =
            Array.isArray(
              expectedAnswers[
                categoryLabel
              ]
            )
              ? expectedAnswers[
                  categoryLabel
                ]
              : [];

          return (
            JSON.stringify(
              sortValues(
                selectedCategory
              )
            ) ===
            JSON.stringify(
              sortValues(
                expectedCategory
              )
            )
          );
        }
      );
  }

  /*
   * =========================================
   * OPTION DRAG AND DROP
   * =========================================
   */
  else if (isDragAndDrop) {
    const expectedAnswers =
      Array.isArray(
        step.correctAnswer
      )
        ? step.correctAnswer
        : [];

    const selectedValues =
      decisionDragAnswer.map(
        (optionId) =>
          getDecisionOptionValueById(
            step,
            optionId
          )
      );

    const normalizeValue = (
      value
    ) =>
      String(value ?? '')
        .trim()
        .toLowerCase();

    const sortValues = (
      values
    ) =>
      [...values]
        .map(
          normalizeValue
        )
        .sort();

    const allSlotsFilled =
      selectedValues.length ===
        expectedAnswers.length &&
      selectedValues.every(
        (value) =>
          value !== null &&
          value !== undefined &&
          value !== ''
      );

    const answerMode =
      step.answerMode ||
      'ordered';

    if (
      answerMode ===
      'unordered'
    ) {
      isCorrect =
        allSlotsFilled &&
        JSON.stringify(
          sortValues(
            selectedValues
          )
        ) ===
        JSON.stringify(
          sortValues(
            expectedAnswers
          )
        );
    }

    else if (
      answerMode ===
      'unorderedPerRow'
    ) {
      let startIndex = 0;

      isCorrect =
        allSlotsFilled &&
        Array.isArray(
          step.rows
        ) &&
        step.rows.every(
          (row) => {
            const rowSlots =
              Math.max(
                0,
                Number(
                  row?.slots
                ) || 0
              );

            const endIndex =
              startIndex +
              rowSlots;

            const selectedRow =
              selectedValues.slice(
                startIndex,
                endIndex
              );

            const expectedRow =
              expectedAnswers.slice(
                startIndex,
                endIndex
              );

            startIndex =
              endIndex;

            return (
              JSON.stringify(
                sortValues(
                  selectedRow
                )
              ) ===
              JSON.stringify(
                sortValues(
                  expectedRow
                )
              )
            );
          }
        );
    }

    else {
      isCorrect =
        allSlotsFilled &&
        selectedValues.every(
          (
            value,
            index
          ) =>
            normalizeValue(
              value
            ) ===
            normalizeValue(
              expectedAnswers[
                index
              ]
            )
        );
    }
  }

  /*
   * =========================================
   * MULTIPLE OPTION
   * =========================================
   */
  else if (isMultiple) {
    const normalizeValue = (
      value
    ) =>
      String(value ?? '')
        .trim()
        .toLowerCase();

    const sortedCorrect =
      Array.isArray(
        step.correctAnswer
      )
        ? [
            ...step.correctAnswer,
          ]
            .map(
              normalizeValue
            )
            .sort()
        : [];

    const sortedSelected =
      Array.isArray(
        decisionSelectedAnswers
      )
        ? [
            ...decisionSelectedAnswers,
          ]
            .map(
              normalizeValue
            )
            .sort()
        : [];

    isCorrect =
      JSON.stringify(
        sortedCorrect
      ) ===
      JSON.stringify(
        sortedSelected
      );
  }

  /*
   * =========================================
   * SIMPLE OPTION
   * =========================================
   */
  else {
    isCorrect =
      String(
        decisionAnswer ?? ''
      )
        .trim()
        .toLowerCase() ===
      String(
        step.correctAnswer ?? ''
      )
        .trim()
        .toLowerCase();
  }

  /*
   * =========================================
   * REZULTAT
   * =========================================
   */
  if (isCorrect) {
    setAnswerStatus(
      'correct'
    );

    handleCorrectCoins();
    grantXpForCorrectAnswer();

    playSoundEffect(
      levelUp
    );

    triggerVibration(
      200
    );
  } else {
    setAnswerStatus(
      'incorrect'
    );

    setLives(
      (prev) =>
        prev - 1
    );

    handleXpResetOnWrongAnswer();

    playSoundEffect(
      error
    );

    triggerVibration([
      300,
      100,
      300,
    ]);
  }

  setIsAnswerChecked(
    true
  );

  setDesableButton(
    false
  );

  setChangeColorButton(
    false
  );

  break;
}



case 'dragAndDropHorizontal': {
  if (!isAnswerChecked) {
    const expected = getHorizontalDragExpectedAnswers(currentQuestion).map((item) => String(item));
    const selectedValues = dataReceived.map((optionId) => getHorizontalOptionValueById(currentQuestion, optionId));

    const allSlotsFilled =
      selectedValues.length === expected.length &&
      selectedValues.every((value) => value !== null && value !== undefined && value !== '');

    const isCorrect = allSlotsFilled &&
      selectedValues.every((value, index) => String(value) === expected[index]);

    if (isCorrect) {
      setAnswerStatus('correct');
      handleCorrectCoins();
      grantXpForCorrectAnswer();
      playSoundEffect(levelUp);
      triggerVibration(200);
    } else {
      setAnswerStatus('incorrect');
      setLives(prev => prev - 1);
      handleXpResetOnWrongAnswer();
      setSimpleCorrectAnswer(expected);
      playSoundEffect(error);
      triggerVibration([300, 100, 300]);
    }

    setIsAnswerChecked(true);
    setChangeColorButton(false);
  } else {
    const slotsCount = getHorizontalDragSlotsCount(currentQuestion);
    setDataReceived(Array(slotsCount).fill(null));
    setIsAnswerChecked(false);
    setChangeColorButton(false);
    toNextQuestion();
  }
  break;
}


        
case 'classificationOption': {
  if (!isAnswerChecked) {
    const normalizeValue = (value) =>
      String(value ?? '')
        .trim()
        .toLowerCase();

    const categories =
      Array.isArray(
        currentQuestion.categories
      )
        ? currentQuestion.categories
        : [];

    const expectedAnswers =
      currentQuestion.correctAnswer &&
      typeof currentQuestion.correctAnswer ===
        'object' &&
      !Array.isArray(
        currentQuestion.correctAnswer
      )
        ? currentQuestion.correctAnswer
        : {};

    const isCorrect =
      categories.length > 0 &&
      categories.every(
        (category) => {
          const label =
            category.label;

          const selected =
            Array.isArray(
              classificationAnswers[
                label
              ]
            )
              ? classificationAnswers[
                  label
                ]
              : [];

          const expected =
            Array.isArray(
              expectedAnswers[label]
            )
              ? expectedAnswers[label]
              : [];

          const normalizedSelected =
            selected
              .map(normalizeValue)
              .sort();

          const normalizedExpected =
            expected
              .map(normalizeValue)
              .sort();

          return (
            JSON.stringify(
              normalizedSelected
            ) ===
            JSON.stringify(
              normalizedExpected
            )
          );
        }
      );

    if (isCorrect) {
      setAnswerStatus('correct');
      playSoundEffect(levelUp);
      handleCorrectCoins();
      grantXpForCorrectAnswer();
      triggerVibration(200);
    } else {
      setAnswerStatus('incorrect');
      setLives(
        (previousLives) =>
          previousLives - 1
      );
      handleXpResetOnWrongAnswer();
      playSoundEffect(error);
      triggerVibration(
        [300, 100, 300]
      );
    }

    setIsAnswerChecked(true);
    setDesableButton(false);
    setTextButton('Continua');
    setChangeColorButton(false);
  } else {
    setClassificationAnswers({});
    setIsAnswerChecked(false);
    setAnswerStatus(null);
    setTextButton('Verifica');
    setChangeColorButton(false);
    toNextQuestion();
  }

  break;
}




        
        case 'activPasivOptionDrag': {
        if (!isAnswerChecked) {
          const expectedAnswers = Array.isArray(currentQuestion.correctAnswer)
            ? currentQuestion.correctAnswer
            : [];
          const selectedValues = generalDragAnswer.map((optionId) =>
            getGeneralOptionValueById(currentQuestion, optionId)
          );

          const allSlotsFilled = selectedValues.length === expectedAnswers.length &&
            selectedValues.every((value) => value !== null && value !== undefined && value !== '');

          const normalizeValue = (value) => String(value ?? '').trim();
          const sortValues = (values) => values
            .map((value) => normalizeValue(value))
            .filter((value) => value !== '')
            .sort((a, b) => a.localeCompare(b, 'ro', { sensitivity: 'base' }));

          let isCorrect = allSlotsFilled &&
            selectedValues.every((value, idx) => value === expectedAnswers[idx]);

          if (currentQuestion.type === 'activPasivOptionDrag') {
            const { activCount } = getActivPasivSplitConfig(currentQuestion);

            const expectedLeft = expectedAnswers.slice(0, activCount);
            const expectedRight = expectedAnswers.slice(activCount);
            const selectedLeft = selectedValues.slice(0, activCount);
            const selectedRight = selectedValues.slice(activCount);

            const leftMatches = JSON.stringify(sortValues(selectedLeft)) === JSON.stringify(sortValues(expectedLeft));
            const rightMatches = JSON.stringify(sortValues(selectedRight)) === JSON.stringify(sortValues(expectedRight));

            isCorrect = allSlotsFilled && leftMatches && rightMatches;
          }

          if (isCorrect) {
            setMessage('');
            setAnswerStatus('correct');
            handleCorrectCoins();
            grantXpForCorrectAnswer();
            playSoundEffect(levelUp);
            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            setLives(prev => prev - 1);
            handleXpResetOnWrongAnswer();
            playSoundEffect(error);
            triggerVibration([300, 100, 300]);
          }

          setIsAnswerChecked(true);
          setChangeColorButton(false);
        } else {
          setIsAnswerChecked(false);
          const slotsCount = getDecisionDragSlotsCount(currentQuestion);
          setGeneralDragAnswer(Array(slotsCount).fill(null));
          setMessage('');
          setTextButton('Verifica');
          setChangeColorButton(true);
          toNextQuestion();
        }
        break;
      }

      case 'multipleSelect':
        if (!isAnswerChecked) {
          // Verificăm dacă răspunsurile selectate de utilizator sunt corecte
          const sortedSelected = [...selectedAnswers].sort();  // Sortăm o copie pentru comparație
          const sortedCorrect = [...currentQuestion.correctAnswer].sort();  // Sortăm răspunsurile corecte
          
          if (JSON.stringify(sortedSelected) === JSON.stringify(sortedCorrect)) {
           setMessage('');
            setAnswerStatus('correct');
            playSoundEffect(levelUp);
            setSimpleCorrectAnswer(false);
           handleCorrectCoins();

             grantXpForCorrectAnswer();


            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





            playSoundEffect(error);
            setSimpleCorrectAnswer(currentQuestion.correctAnswer);
            triggerVibration([300, 100, 300]);
          }
          setIsAnswerChecked(true);  // Marchez răspunsul ca verificat
        
          setChangeColorButton(false);
        } else {
          // A doua fază: Trecem la următoarea întrebare
          setIsAnswerChecked(false);  // Resetează starea de verificare
          setSelectedAnswers([]);  // Resetează răspunsurile selectate
          setMessage('');  // Resetează mesajul
      
          setChangeColorButton(false);
          toNextQuestion();  // Trecem la următoarea întrebare
        }
        break;

        case 'optionDragAndDropFormulaLeft': {
          if (!isAnswerChecked) {
            const expectedAnswers = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.map((item) => String(item))
              : [];
            const userAnswers = Array.isArray(dataReceived)
              ? dataReceived.map((item) => (item === null || item === undefined ? '' : String(item)))
              : [];

            const isCorrect = userAnswers.length === expectedAnswers.length &&
              expectedAnswers.every((val, idx) => userAnswers[idx] === val);

            if (isCorrect) {
              setMessage('');
              setAnswerStatus('correct');
              handleCorrectCoins();
              grantXpForCorrectAnswer();
              playSoundEffect(levelUp);
              triggerVibration(200);
            } else {
              setMessage('');
              setAnswerStatus('incorrect');
              setLives(prev => prev - 1);
              handleXpResetOnWrongAnswer();
              playSoundEffect(error);
              triggerVibration([300, 100, 300]);
            }

            setIsAnswerChecked(true);
            setChangeColorButton(false);
          } else {
            setIsAnswerChecked(false);
            const slotsCount = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.length
              : 8;
            setDataReceived(Array(slotsCount).fill(null));
            setMessage('');
            setTextButton('Verifica');
            setChangeColorButton(true);
            toNextQuestion();
          }
          break;
        }


        case 'generalOptionDrag': {
  if (!isAnswerChecked) {
    const expectedAnswers = Array.isArray(currentQuestion.correctAnswer)
      ? currentQuestion.correctAnswer
      : [];

    const selectedValues = generalDragAnswer.map((optionId) =>
      getGeneralOptionValueById(currentQuestion, optionId)
    );

    const allSlotsFilled =
      selectedValues.length === expectedAnswers.length &&
      selectedValues.every(
        (value) =>
          value !== null &&
          value !== undefined &&
          value !== ''
      );

    const normalize = (value) =>
      String(value ?? '')
        .trim()
        .toLowerCase();

    const sortValues = (values) =>
      values
        .map(normalize)
        .sort();

    let isCorrect = false;

    switch (currentQuestion.answerMode) {
      case 'unordered':
        isCorrect =
          allSlotsFilled &&
          JSON.stringify(
            sortValues(selectedValues)
          ) ===
          JSON.stringify(
            sortValues(expectedAnswers)
          );
        break;

      case 'unorderedPerRow': {
        let startIndex = 0;

        isCorrect =
          allSlotsFilled &&
          currentQuestion.rows.every((row) => {
            const slots =
              Number(row?.slots) || 0;

            const endIndex =
              startIndex + slots;

            const selectedRow =
              selectedValues.slice(
                startIndex,
                endIndex
              );

            const expectedRow =
              expectedAnswers.slice(
                startIndex,
                endIndex
              );

            startIndex = endIndex;

            return (
              JSON.stringify(
                sortValues(selectedRow)
              ) ===
              JSON.stringify(
                sortValues(expectedRow)
              )
            );
          });

        break;
      }

      default:
        isCorrect =
          allSlotsFilled &&
          selectedValues.every(
            (value, index) =>
              normalize(value) ===
              normalize(
                expectedAnswers[index]
              )
          );
    }

    if (isCorrect) {
      setAnswerStatus('correct');
      playSoundEffect(levelUp);
      handleCorrectCoins();
      grantXpForCorrectAnswer();
      triggerVibration(200);
    } else {
      setAnswerStatus('incorrect');
      setLives((prev) => prev - 1);
      handleXpResetOnWrongAnswer();
      playSoundEffect(error);
      triggerVibration([300, 100, 300]);
    }

    setIsAnswerChecked(true);
    setDesableButton(false);
    setChangeColorButton(false);
  } else {
    setIsAnswerChecked(false);
    setGeneralDragAnswer([]);
    toNextQuestion();
  }

  break;
}

        case 'optionDragAndDropFormulaRight': {
          if (!isAnswerChecked) {
            const expectedAnswers = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.map((item) => String(item))
              : [];
            const userAnswers = Array.isArray(dataReceived)
              ? dataReceived.map((item) => (item === null || item === undefined ? '' : String(item)))
              : [];

            const isCorrect = userAnswers.length === expectedAnswers.length &&
              expectedAnswers.every((val, idx) => userAnswers[idx] === val);

            if (isCorrect) {
              setMessage('');
              setAnswerStatus('correct');
              handleCorrectCoins();
              grantXpForCorrectAnswer();
              playSoundEffect(levelUp);
              triggerVibration(200);
            } else {
              setMessage('');
              setAnswerStatus('incorrect');
              setLives(prev => prev - 1);
              handleXpResetOnWrongAnswer();
              playSoundEffect(error);
              triggerVibration([300, 100, 300]);
            }

            setIsAnswerChecked(true);
            setChangeColorButton(false);
          } else {
            setIsAnswerChecked(false);
            const slotsCount = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.length
              : 8;
            setDataReceived(Array(slotsCount).fill(null));
            setMessage('');
            setTextButton('Verifica');
            setChangeColorButton(true);
            toNextQuestion();
          }
          break;
        }
        break;



      
         
          setIsLessonFinished(true)
        
        break;
      default:
       <p>'Tipul întrebării nu este recunoscut'</p> 
    }
  };
  

  const handleInputChange = (index, value) => {
    const updatedInput = {
      ...userInput,
      [index]: value  // Actualizăm răspunsul pentru fiecare index
    };
    
    setUserInput(updatedInput);

   
  
    // Verificăm dacă s-au introdus date în cel puțin un câmp de input
    const hasData = Object.values(updatedInput).some(val => val.trim() !== '');
    
    // Schimbăm textul butonului dacă există input
    if (hasData) {
      setTextButton('Verifica');
    
      setChangeColorButton(true);
    } else {
      setTextButton('Continua');
    }
  };
 



// Funcția pentru a actualiza răspunsurile selectate
const handleCheckboxChange = (option) => {
  setSelectedAnswers(prevSelected => {
    let updatedSelected;
    
    if (prevSelected.includes(option)) {
      // Dacă opțiunea este deja selectată, o eliminăm din array
      updatedSelected = prevSelected.filter(answer => answer !== option);
    } else {
      // Adăugăm opțiunea selectată
      updatedSelected = [...prevSelected, option];
    }
    
    // Verificăm dacă mai sunt opțiuni selectate
    setDesableButton(updatedSelected.length === 0); // Dezactivează butonul dacă nu e nimic selectat
    return updatedSelected; // Returnează lista actualizată de răspunsuri selectate
  });

  // După fiecare schimbare, setăm textul butonului la "Verifică"
  setTextButton('Verifica');
 
  setChangeColorButton(true);
};

const [finalMessage, setFinalMessage] = useState(false);
const [isLessonCompletionBarDone, setIsLessonCompletionBarDone] = useState(false);

useEffect(() => {
  const activeQuestionType = lessonData?.questions?.[nextQuestion]?.type;

  if (activeQuestionType === 'lessonCompletion') {
    setIsLessonCompletionBarDone(false);
  }
}, [lessonData, nextQuestion]);

useEffect(() => {
  if (isLessonFinished) {
    finalizeLesson();
  }
}, [isLessonFinished]);


const [showFinalTitle, setShowFinalTitle] = useState(false);

useEffect(() => {
  if (finalMessage) {
    setShowFinalTitle(false); // resetăm înainte
    const timer = setTimeout(() => {
      setShowFinalTitle(true);  // apare cu întârziere
    }, 2500);

    return () => clearTimeout(timer);
  }
}, [finalMessage]);


const [successBubbleText, setSuccessBubbleText] = useState('Felicitari!');
const [successBubblePhase, setSuccessBubblePhase] = useState('initial'); // 'initial' | 'transition' | 'final'

useEffect(() => {
  // Resetează textul când se finalizează lecția
  if (isLessonFinished) {
    setSuccessBubbleText('Felicitari!');
    setSuccessBubblePhase('initial');
    
    // După 1.5 secunde, schimbă textul cu animație
    const timer = setTimeout(() => {
      setSuccessBubblePhase('transition');
      
      // Schimbă textul după ce animația de ieșire s-a terminat
      setTimeout(() => {
        setSuccessBubbleText('Ai terminat cu succes lectia');
        setSuccessBubblePhase('initial'); // Reset la initial pentru a putea aplica slideInRight
      }, 600); // Timing complet cu slide-out animation (0.6s)
      
      // Schimbă la 'final' pentru a porni slideInRight
      setTimeout(() => {
        setSuccessBubblePhase('final');
      }, 610); // Puțin după ce textul s-a schimbat
    }, 1500);

    return () => clearTimeout(timer);
  }
}, [isLessonFinished]);



const areAllFieldsCompleted = useCallback(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return false;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  if (!currentQuestion) return false;

  switch (currentQuestion.type) {
    
    case 'dragAndDropHorizontal':
      {
        const slotsCount = getHorizontalDragSlotsCount(currentQuestion);
        return (
          slotsCount > 0 &&
          dataReceived.length === slotsCount &&
          dataReceived.every((val) => val !== null && val !== undefined && val !== '')
        );
      } case 'optionDragAndDropFormulaLeft': {
      const slotsCount = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer.length : 8;
      return dataReceived.length === slotsCount && dataReceived.every(val => val !== null && val !== undefined && val !== '');
    }
    case 'optionDragAndDropFormulaRight': {
      const slotsCount = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer.length : 8;
      return dataReceived.length === slotsCount && dataReceived.every(val => val !== null && val !== undefined && val !== '');
    }

case 'formulaDragAndDrop': {
  const expectedAnswers =
    currentQuestion.correctAnswer &&
    typeof currentQuestion.correctAnswer === 'object' &&
    !Array.isArray(currentQuestion.correctAnswer)
      ? currentQuestion.correctAnswer
      : {};

  const requiredSlotIds =
    Object.keys(expectedAnswers);

  return (
    requiredSlotIds.length > 0 &&
    requiredSlotIds.every(
      (slotId) =>
        formulaDragAnswers[slotId] !== null &&
        formulaDragAnswers[slotId] !== undefined &&
        formulaDragAnswers[slotId] !== ''
    )
  );
}

    default:
      return true;
  }

  
  
}, [lessonData, nextQuestion, dataReceived, formulaDragAnswers]);


const handleFeedback = (type) => {
  if (type === 'like') {
    console.log("Utilizatorul a apreciat lecția.");
    // poți trimite către un API, localStorage etc.
  } else {
    console.log("Utilizatorul nu a fost mulțumit.");
  }

  // opțional: afișează un mesaj de mulțumire sau închide feedbackul
};








useEffect(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  switch (currentQuestion.type) {
    case 'trueFalseQuiz':
    case 'cresteScadeQuiz':
      setDesableButton(simpleSelectType === null);
      break;

    case 'simpleSelect':
      // Dezactivăm butonul dacă nu s-a selectat încă un răspuns
      setDesableButton(simpleSelectType === null);
      break;

    case 'multipleSelect':
      // Dezactivăm butonul dacă nu s-a selectat încă un răspuns
      setDesableButton(selectedAnswers.length === 0);
      break;
case 'formulaDragAndDrop':
  setDesableButton(
    !areAllFieldsCompleted()
  );

  setTextButton('Verifica');

  setChangeColorButton(
    areAllFieldsCompleted()
  );

  break;

case 'simpleApplication': {
  const applicationType =
    currentQuestion.applicationType ||
    'simpleSelect';

  if (
    applicationType ===
    'simpleSelect'
  ) {
    setDesableButton(
      simpleSelectType === null
    );
    break;
  }

  if (
    applicationType ===
    'multipleSelect'
  ) {
    const hasSelectedAnswers =
      Array.isArray(
        selectedAnswers
      ) &&
      selectedAnswers.length > 0;

    setDesableButton(
      !hasSelectedAnswers
    );

    setTextButton('Verifica');
    setChangeColorButton(
      hasSelectedAnswers
    );

    break;
  }

  if (
    applicationType ===
    'dragAndDropHorizontal'
  ) {
    const slotsCount =
      getHorizontalDragSlotsCount(
        currentQuestion
      );

    const allSlotsFilled =
      slotsCount > 0 &&
      dataReceived.length ===
        slotsCount &&
      dataReceived.every(
        (answer) =>
          answer !== null &&
          answer !== undefined &&
          answer !== ''
      );

    setDesableButton(
      !allSlotsFilled
    );
    break;
  }

  if (
    applicationType ===
    'generalOptionDrag'
  ) {
    const allSlotsFilled =
      Array.isArray(
        generalDragAnswer
      ) &&
      generalDragAnswer.length > 0 &&
      generalDragAnswer.every(
        (answer) =>
          answer !== null &&
          answer !== undefined &&
          answer !== ''
      );

    setDesableButton(
      !allSlotsFilled
    );
    break;
  }

  if (
    applicationType ===
    'classificationOption'
  ) {
    const placedOptionsCount =
      Object.values(
        classificationAnswers || {}
      )
        .filter(Array.isArray)
        .reduce(
          (total, answers) =>
            total + answers.length,
          0
        );

    const optionsCount =
      Array.isArray(
        currentQuestion.options
      )
        ? currentQuestion.options.length
        : 0;

    setDesableButton(
      optionsCount === 0 ||
      placedOptionsCount !==
        optionsCount
    );
    break;
  }

  setDesableButton(true);
  break;
}

case 'decisionFlowApplication': {
  if (decisionPhase !== 'steps') {
    setDesableButton(false);
    break;
  }

  const step =
    currentQuestion.steps?.[
      decisionStepIndex
    ];

  if (!step) {
    setDesableButton(true);
    break;
  }

  const optionType =
    step.type === 'formulaDragAndDrop'
      ? 'formulaDragAndDrop'
      : (
          step.optionType ||
          step.stepType ||
          (
            typeof step.type === 'string'
              ? step.type
              : 'simpleOption'
          )
        );

  /*
   * FORMULA DRAG AND DROP
   */
  if (
    optionType ===
    'formulaDragAndDrop'
  ) {
    const expectedAnswers =
      step.correctAnswer &&
      typeof step.correctAnswer ===
        'object' &&
      !Array.isArray(
        step.correctAnswer
      )
        ? step.correctAnswer
        : {};

    const requiredSlotIds =
      Object.keys(
        expectedAnswers
      );

    const allSlotsFilled =
      requiredSlotIds.length > 0 &&
      requiredSlotIds.every(
        (slotId) =>
          formulaDragAnswers[
            slotId
          ] !== null &&
          formulaDragAnswers[
            slotId
          ] !== undefined &&
          formulaDragAnswers[
            slotId
          ] !== ''
      );

    setDesableButton(
      !allSlotsFilled
    );

    setTextButton('Verifica');

    setChangeColorButton(
      allSlotsFilled
    );

    break;
  }

  /*
   * CLASSIFICATION OPTION
   */
  if (
    optionType ===
    'classificationOption'
  ) {
    const categories =
      Array.isArray(
        step.categories
      )
        ? step.categories
        : [];

    const requiredSlotsCount =
      categories.reduce(
        (
          total,
          category
        ) => {
          const slots =
            Number(
              category?.slots
            );

          return (
            total +
            (
              Number.isFinite(
                slots
              ) &&
              slots > 0
                ? slots
                : 0
            )
          );
        },
        0
      );

    const placedOptionsCount =
      Object.values(
        classificationAnswers ||
          {}
      )
        .filter(
          Array.isArray
        )
        .reduce(
          (
            total,
            answers
          ) =>
            total +
            answers.length,
          0
        );

    const allSlotsFilled =
      requiredSlotsCount > 0 &&
      placedOptionsCount ===
        requiredSlotsCount;

    setDesableButton(
      !allSlotsFilled
    );

    setTextButton(
      'Verifica'
    );

    setChangeColorButton(
      allSlotsFilled
    );

    break;
  }

  /*
   * MULTIPLE OPTION
   */
  if (
    optionType ===
    'multipleOption'
  ) {
    const hasSelection =
      Array.isArray(
        decisionSelectedAnswers
      ) &&
      decisionSelectedAnswers
        .length > 0;

    setDesableButton(
      !hasSelection
    );

    setTextButton(
      'Verifica'
    );

    setChangeColorButton(
      hasSelection
    );

    break;
  }

  /*
   * DRAG AND DROP
   */
  if (
    optionType ===
      'optionDragAndDrop' ||
    optionType ===
      'optionDragAndDropFormula' ||
    optionType ===
      'optionDragAndDropFormulaLeft' ||
    optionType ===
      'optionDragAndDropFormulaRight' ||
    optionType ===
      'optionDragTaccount'
  ) {
    const requiredSlotsCount =
      getDecisionDragSlotsCount(
        step
      );

    const allSlotsFilled =
      requiredSlotsCount > 0 &&
      Array.isArray(
        decisionDragAnswer
      ) &&
      decisionDragAnswer.length ===
        requiredSlotsCount &&
      decisionDragAnswer.every(
        (item) =>
          item !== null &&
          item !== undefined &&
          item !== ''
      );

    setDesableButton(
      !allSlotsFilled
    );

    setTextButton(
      'Verifica'
    );

    setChangeColorButton(
      allSlotsFilled
    );

    break;
  }

  /*
   * SIMPLE OPTION
   */
  const hasAnswer =
    decisionAnswer !== null &&
    decisionAnswer !==
      undefined &&
    decisionAnswer !== '';

  setDesableButton(
    !hasAnswer
  );

  setTextButton(
    'Verifica'
  );

  setChangeColorButton(
    hasAnswer
  );

  break;
}


case 'classificationOption': {
  const categories =
    Array.isArray(currentQuestion.categories)
      ? currentQuestion.categories
      : [];

  const requiredSlotsCount =
    categories.reduce(
      (total, category) => {
        const slots =
          Number(category?.slots);

        return total +
          (
            Number.isFinite(slots) &&
            slots > 0
              ? slots
              : 0
          );
      },
      0
    );

  const placedOptionsCount =
    Object.values(
      classificationAnswers
    )
      .filter(Array.isArray)
      .reduce(
        (total, answers) =>
          total + answers.length,
        0
      );

  const allSlotsFilled =
    requiredSlotsCount > 0 &&
    placedOptionsCount ===
      requiredSlotsCount;

  setDesableButton(
    !allSlotsFilled
  );

  setTextButton('Verifica');

  setChangeColorButton(
    allSlotsFilled
  );

  break;
}


    case 'manualInput':
      // Verificăm dacă toate câmpurile de input sunt completate
      const allFilled = currentQuestion.correctAnswer.every((_, idx) => {
        return userInput[idx] && userInput[idx].trim() !== '';
      });
      setDesableButton(!allFilled);
      break;



      case 'dragAndDropHorizontal':
      // Verificăm dacă toate elementele au fost mutate corect
      setDesableButton(!areAllFieldsCompleted());
      break;


    case 'orderSelectionDrag':
        case 'generalOptionDrag':
        case 'activPasivOptionDrag': {
      const allFilled = Array.isArray(generalDragAnswer) && generalDragAnswer.every(
        (value) => value !== null && value !== undefined && value !== ''
      );
      setDesableButton(!allFilled);
      break;
    }

    case 'optionDragAndDropFormulaLeft': {
      const slotsCount = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer.length : 8;
      const allFilled =
        slotsCount > 0 &&
        dataReceived.length === slotsCount &&
        dataReceived.every((v) => v !== null && v !== undefined && v !== '');
      setDesableButton(!allFilled);
      break;
    }

    case 'optionDragAndDropFormulaRight': {
      const slotsCount = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer.length : 8;
      const allFilled =
        slotsCount > 0 &&
        dataReceived.length === slotsCount &&
        dataReceived.every((v) => v !== null && v !== undefined && v !== '');
      setDesableButton(!allFilled);
      break;
    }

    default:
      // Activăm butonul pentru explanationLesson și lessonResume
      setDesableButton(false);
      break;
  }
}, [
  simpleSelectType,
  selectedAnswers,
  userInput,
  dataReceived,
  nextQuestion,
  lessonData,
  formulaDragAnswers,
  decisionPhase,
  decisionStepIndex,
  decisionAnswer,
  decisionSelectedAnswers,
  decisionDragAnswer,
  classificationAnswers,
  areAllFieldsCompleted
]);








const renderContent = () => {
  // dacă am trecut de ultima întrebare, nu mai randăm conținut de întrebare
  if (!lessonData || !lessonData.questions) return null;
  if (nextQuestion >= lessonData.questions.length) return null;

  if (isLessonFinished && finalMessage) {
    return null; // ascunde conținutul lecției când e final
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  switch (currentQuestion.type) {
   case 'lessonCompletion':
  return (
    <LessonCompletion
      question={currentQuestion}
      characterImage={final_congrats_conti}
      confettiImage={confettyFinish}
      onProgressComplete={() => {
        setIsLessonCompletionBarDone(true);
      }}
    />
  );



case 'feedbackLesson':
  return (
    <FeedBackLesson
      ref={feedbackLessonRef}
      lessonId={lessonId}
      chapterId={chapterId}
      apiUrl={apiUrl}
      onFeedbackChange={(hasFeedback) => {
        setHasLessonFeedback(
          hasFeedback
        );

        setDesableButton(
          !hasFeedback
        );

        setTextButton('Continua');

        setChangeColorButton(
          hasFeedback
        );
      }}
    />
  );

case 'explanationLesson':
  return (
    <ExplanationLesson
      question={currentQuestion}
      cardIndex={cardIndex}
      onCardIndexChange={handleCardChange}
      onUnlockContinue={handleUnlockExplanationContinue}
    />
  );

case 'formulaExplanationLesson':
  return (
    <FormulaExplanationLesson
      question={currentQuestion}
      cardIndex={cardIndex}
      onCardIndexChange={handleCardChange}
      onUnlockContinue={handleUnlockExplanationContinue}
    />
  );

case 'formulaDragAndDrop':
  return (
    <FormulaDragAndDrop
      question={currentQuestion}
      options={shuffledFormulaDragOptions}
      selectedAnswers={formulaDragAnswers}
      expectedAnswers={currentQuestion.correctAnswer || {}}
      isAnswerChecked={isAnswerChecked}
      formulaRows={currentQuestion.formulaRows || []}
      onAnswersChange={handleFormulaDragAnswersChange}
      showQuestion={true}
    />
  );
  

  
  case 'giftlesson':
      {
      const giftLives = Math.max(1, Number(currentQuestion.giftLives) || 1);
      const giftCoins = Math.max(1, Number(currentQuestion.giftCoins) || 20);
      const giftXp = Math.max(1, Number(currentQuestion.giftXp) || 50);
      const giftRewardKeys = getGiftRewardKeysForQuestion(currentQuestion);
      const effectiveGiftRewardKeys = isReplayLesson
        ? giftRewardKeys.filter((rewardKey) => rewardKey !== 'coins')
        : giftRewardKeys;

      const giftOptions = [
        {
          key: 'lives',
          icon: '❤',
          title: 'Vieti',
          valueLabel: `+${giftLives}`
        },
        {
          key: 'coins',
          icon: '🪙',
          image: coinImg,
          title: 'Monede',
          valueLabel: `+${giftCoins} coins`
        },
        {
          key: 'xp',
          icon: '⭐',
          image: boltImg,
          title: 'XP',
          valueLabel: `+${giftXp}`
        }
      ].filter((option) => effectiveGiftRewardKeys.includes(option.key));

      const isSingleGiftOption = giftOptions.length === 1;
      const singleGiftOption = isSingleGiftOption ? giftOptions[0] : null;
      const selectedRewardIsAvailable = effectiveGiftRewardKeys.includes(selectedGiftReward);
      const balanceRewardKey = selectedRewardIsAvailable
        ? selectedGiftReward
        : (singleGiftOption?.key || effectiveGiftRewardKeys[0] || 'lives');
      const balanceLabel =
        balanceRewardKey === 'xp'
          ? 'XP curent'
          : balanceRewardKey === 'lives'
          ? 'Vieti curente'
          : 'Sold curent';
      const balanceValue =
        balanceRewardKey === 'xp'
          ? xp
          : balanceRewardKey === 'lives'
          ? lives
          : coinCount;

      return (
        <div className="quiz-content-scroll-bc quiz-content-scroll-gift-bc">
          <div className="gift-lesson-container">
            <div className="gift-lesson-top">
           
            </div>
            <div className="gift-lesson-middle">
              <div className="gift-balance-summary-bc">
                <span className="gift-balance-summary-label-bc">{balanceLabel}</span>
                <span className="gift-balance-summary-value-bc">
                  {balanceRewardKey === 'xp' ? (
                    <img src={boltImg} alt="XP" className="gift-balance-summary-icon-bc" />
                  ) : balanceRewardKey === 'lives' ? (
                    <span className="gift-balance-summary-icon-bc">❤</span>
                  ) : (
                    <img src={coinImg} alt="Monede" className="gift-balance-summary-icon-bc" />
                  )}
                  {balanceValue}
                </span>
              
              </div>

              <div className="gift-lesson-content">
                {Array.isArray(currentQuestion.giftMessages)
                  ? currentQuestion.giftMessages.map((msg, idx) => (
                      <div key={idx} className="gift-message" dangerouslySetInnerHTML={{ __html: msg }} />
                    ))
                  : <div className="gift-message" dangerouslySetInnerHTML={{ __html: currentQuestion.giftMessages }} />}
              </div>

              {isSingleGiftOption ? (
                <div className="gift-single-reward-display">
                  {showGiftClaimEffect && (
                    <div className="gift-claim-effect gift-claim-effect-overlay">{giftClaimEffectLabel}</div>
                  )}

                  {singleGiftOption?.image ? (
                    <img
                      src={singleGiftOption.image}
                      alt={singleGiftOption.title}
                      className="gift-single-reward-image"
                    />
                  ) : (
                    <span className="gift-single-reward-icon">{singleGiftOption?.icon || '🎁'}</span>
                  )}
                 
                </div>
              ) : (
                <div className="gift-reward-options-grid">
                  {giftOptions.map((option) => (
                    <button
                      key={option.key}
                      type="button"
                      className={`gift-reward-option ${selectedGiftReward === option.key ? 'active' : ''}`}
                      onClick={() => setSelectedGiftReward(option.key)}
                      disabled={giftRewardClaimed}
                    >
                      <span className="gift-reward-option-icon">{option.icon}</span>
                      <span className="gift-reward-option-title">{option.title}</span>
                      <span className="gift-reward-option-value">{option.valueLabel}</span>
                    </button>
                  ))}
                </div>
              )}

              {(currentQuestion.giftImage || contiRevendicare) && (
                <div className="gift-lesson-image-container">
                  <img
                    src={currentQuestion.giftImage || (giftRewardClaimed ? contiRevendicat : contiRevendicare)}
                    alt="Conti"
                    className={`gift-lesson-image ${
                      currentQuestion.giftImage
                        ? ''
                        : (giftRewardClaimed ? 'gift-lesson-image-claimed' : 'gift-lesson-image-initial')
                    }`}
                  />
                </div>
              )}
            </div>
            <div className="gift-lesson-bottom">
              <button
                type="button"
                className="gift-claim-button"
                disabled={isGiftClaimProcessing || (!giftRewardClaimed && (!selectedGiftReward || !selectedRewardIsAvailable))}
                onClick={async () => {
                  if (giftRewardClaimed) {
                    if (isGiftClaimProcessing) {
                      return;
                    }

                    setHideActionButton(false);
                    toNextQuestion();
                    return;
                  }

                  if (!selectedGiftReward || !selectedRewardIsAvailable) {
                    return;
                  }

                  setGiftRewardClaimed(true);
                  setIsGiftClaimProcessing(true);
                  setGiftClaimEffectLabel(
                    getGiftEffectLabel({
                      rewardKey: selectedGiftReward,
                      lives: giftLives,
                      coins: giftCoins,
                      xp: giftXp
                    })
                  );
                  setShowGiftClaimEffect(true);

                  if (selectedGiftReward === 'lives') {
                    setLives((prev) => prev + giftLives);
                  } else if (selectedGiftReward === 'coins' && !isReplayLesson) {
                    await addCoins(giftCoins);
                  } else if (selectedGiftReward === 'xp') {
                    await addXp(giftXp);
                  }

                  if (giftClaimEffectTimeoutRef.current) {
                    clearTimeout(giftClaimEffectTimeoutRef.current);
                  }

                  giftClaimEffectTimeoutRef.current = setTimeout(() => {
                    setShowGiftClaimEffect(false);
                  }, 850);

                  if (!lessonCompletionSentRef.current) {
                    const earnedXpForGiftCompletion =
                      Number(lessonXp || 0) + (selectedGiftReward === 'xp' ? Number(giftXp || 0) : 0);

                    await sendLessonCompletion(currentQuestion.type, earnedXpForGiftCompletion);
                    lessonCompletionSentRef.current = true;
                  }

                  setIsGiftClaimProcessing(false);
                }}
              >
                {giftRewardClaimed ? 'Continua' : 'Revendica'}
              </button>
            </div>
       
          </div>
        </div>
      );
      }


      case 'trueFalseQuiz':
        return (
          <div className="quiz-content-scroll-bc">
            <div className='explanation-lesoon-container-bc'>
              <div className='title-simple-select-align'>
                
                  <div className="question-text-bc">{currentQuestion.question}</div>
                
              </div>
              <div className='true-false-buttons-bc'>
                {['Adevarat', 'Fals'].map(option => {
                  let className = 'true-false-btn-bc';
                  if (isAnswerChecked) {
                    if (option === currentQuestion.correctAnswer) {
                      className = 'true-false-btn-bc true-false-correct-bc';
                    } else if (option === simpleSelectType) {
                      className = 'true-false-btn-bc true-false-incorrect-bc';
                    }
                  } else if (simpleSelectType === option) {
                    className = 'true-false-btn-bc true-false-selected-bc';
                  }
                  return (
                    <button
                      key={option}
                      className={className}
                      disabled={isAnswerChecked}
                      onClick={() => {
                        setSimpleSelectType(option);
                        setDesableButton(false);
                        setTextButton('Verifica');
                        setChangeColorButton(true);
                      }}
                    >
                      {option === 'Adevarat'
                        ? <span>✔ Adevarat</span>
                        : <span>✘ Fals</span>
                      }
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        );

      case 'cresteScadeQuiz':
        return (
          <div className="quiz-content-scroll-bc">
            <div className='explanation-lesoon-container-bc'>
              <div className='title-simple-select-align'>
                <div className="centred-simple-element">
                  <span className="question-text-bc">{currentQuestion.question}</span>
                </div>
              </div>
              <div className='true-false-buttons-bc'>
                {['Creste', 'Scade'].map(option => {
                  let className = 'true-false-btn-bc';
                  if (isAnswerChecked) {
                    if (option === currentQuestion.correctAnswer) {
                      className = 'true-false-btn-bc true-false-correct-bc';
                    } else if (option === simpleSelectType) {
                      className = 'true-false-btn-bc true-false-incorrect-bc';
                    }
                  } else if (simpleSelectType === option) {
                    className = 'true-false-btn-bc true-false-selected-bc';
                  }
                  return (
                    <button
                      key={option}
                      className={className}
                      disabled={isAnswerChecked}
                      onClick={() => {
                        setSimpleSelectType(option);
                        setDesableButton(false);
                        setTextButton('Verifica');
                        setChangeColorButton(true);
                      }}
                    >
                      {option === 'Creste'
                        ? <span>▲ Creste</span>
                        : <span>▼ Scade</span>
                      }
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        );

case 'simpleSelect':
  return (
    <SimpleSelectQuiz
      question={currentQuestion}
      options={shuffledOptions}
      selectedAnswer={simpleSelectType}
      isAnswerChecked={isAnswerChecked}
      onSelectAnswer={handleSingleAnswerSelect}
    />
  );


case 'classificationOption':
  return (
    <ClassificationOption
      question={currentQuestion}
      categories={currentQuestion.categories}
      options={currentQuestion.options}
      answers={classificationAnswers}
      isAnswerChecked={isAnswerChecked}
      onAnswersChange={handleClassificationAnswersChange}
    />
  );



case 'simpleApplication':
  return (
 <SimpleApplication
  question={currentQuestion}
  options={
    shuffledApplicationOptions
  }

  selectedAnswer={
    simpleSelectType
  }
  onSelectAnswer={
    handleSingleAnswerSelect
  }

  selectedAnswers={
    selectedAnswers
  }
  onMultipleAnswersChange={
    handleMultipleAnswerToggle
  }

  dragAnswers={
    dataReceived
  }
  onDragAnswersChange={
    handleHorizontalDragAnswersChange
  }
  getOptionValueById={
    getHorizontalOptionValueById
  }

  generalDragAnswers={
    generalDragAnswer
  }
  onGeneralDragAnswersChange={
    handleGeneralDragAnswerChange
  }
  getGeneralOptionValueById={
    getGeneralOptionValueById
  }

  classificationAnswers={
    classificationAnswers
  }
  onClassificationAnswersChange={
    handleClassificationAnswersChange
  }

  isAnswerChecked={
    isAnswerChecked
  }
/>
  );


case 'generalOptionDrag':
  return (
    <GeneralOptionDrag
      question={currentQuestion}
      options={
        shuffledGeneralDragOptions
      }
      answers={generalDragAnswer}
      isAnswerChecked={
        isAnswerChecked
      }
      onAnswersChange={
        handleGeneralDragAnswerChange
      }
      getOptionValueById={
        getGeneralOptionValueById
      }
    />
  );



case 'activPasivOptionDrag': {
  const apNormalizedOptions = shuffledGeneralDragOptions.length
    ? shuffledGeneralDragOptions
    : (Array.isArray(currentQuestion.options) ? currentQuestion.options : []).map((value, index) => ({
        id: buildGeneralOptionId(index),
        value,
        label: String(value),
      }));

  const {
    slotsCount: apSlotsCount,
    activCount: apActivCount,
    pasivCount: apPasivCount,
  } = getActivPasivSplitConfig(currentQuestion);
  const apExpectedAnswers = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer : [];

  const apNormalizeValue = (value) => String(value ?? '').trim();
  const apExpectedLeft = apExpectedAnswers.slice(0, apActivCount).map(apNormalizeValue);
  const apExpectedRight = apExpectedAnswers.slice(apActivCount).map(apNormalizeValue);

  const apDndOnDragOver = (event) => { event.preventDefault(); };

  const apDndReadDraggedValue = (event) => {
    try {
      const payload = event.dataTransfer.getData('application/json');
      if (payload) {
        const parsed = JSON.parse(payload);
        if (parsed && parsed.id) return parsed.id;
      }
    } catch (err) { /* fallback */ }
    return event.dataTransfer.getData('text/plain');
  };

  const apUpdateDragState = (next) => {
    setGeneralDragAnswer(next);
    const hasSelection = next.some((item) => item !== null && item !== undefined && item !== '');
    setDesableButton(!hasSelection);
    if (hasSelection) {
      setTextButton('Verifica');
      setChangeColorButton(true);
    }
  };

  const apDndPlaceInSlot = (slotIndex, optionId) => {
    if (isAnswerChecked) return;
    const next = Array.isArray(generalDragAnswer) && generalDragAnswer.length === apSlotsCount
      ? [...generalDragAnswer]
      : Array(apSlotsCount).fill(null);
    const existingIndex = next.indexOf(optionId);
    if (existingIndex !== -1) {
      next[existingIndex] = null;
    }

    next[slotIndex] = optionId;
    apUpdateDragState(next);
  };

  const apDndDropOnSlot = (event, slotIndex) => {
    event.preventDefault();
    const optionId = apDndReadDraggedValue(event);
    if (!optionId) return;
    apDndPlaceInSlot(slotIndex, optionId);
  };

  const apDndDropOnOptions = (event) => {
    event.preventDefault();
    if (isAnswerChecked) return;
    const optionId = apDndReadDraggedValue(event);
    if (!optionId) return;
    const next = (Array.isArray(generalDragAnswer) ? generalDragAnswer : Array(apSlotsCount).fill(null))
      .map((item) => (item === optionId ? null : item));
    apUpdateDragState(next);
  };

  const apDndSlotClick = (slotIndex) => {
    if (isAnswerChecked) return;
    const next = Array.isArray(generalDragAnswer) ? [...generalDragAnswer] : Array(apSlotsCount).fill(null);
    next[slotIndex] = null;
    apUpdateDragState(next);
  };

  const apDndOptionClick = (optionId) => {
    if (isAnswerChecked) return;
    const firstEmpty = (Array.isArray(generalDragAnswer) ? generalDragAnswer : Array(apSlotsCount).fill(null))
      .findIndex((item) => item === null || item === undefined || item === '');
    if (firstEmpty !== -1) {
      apDndPlaceInSlot(firstEmpty, optionId);
    }
  };

  const apDndDragStartOption = (event, optionId) => {
    event.dataTransfer.setData('application/json', JSON.stringify({ id: optionId }));
    event.dataTransfer.setData('text/plain', String(optionId));
  };

  const apRenderSlot = (slotIndex) => {
    const optionId = generalDragAnswer[slotIndex] ?? null;
    const value = getGeneralOptionValueById(currentQuestion, optionId) || '';
    const valueNormalized = apNormalizeValue(value);
    const expectedValuesForSide = slotIndex < apActivCount ? apExpectedLeft : apExpectedRight;
    const isCorrectSlot = isAnswerChecked && valueNormalized && expectedValuesForSide.includes(valueNormalized);
    const isWrongSlot = isAnswerChecked && valueNormalized && !expectedValuesForSide.includes(valueNormalized);
    return (
      <button
        key={`ap-slot-${slotIndex}`}
        type="button"
        className={`decision-dnd-slot-bc ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
        onDragOver={apDndOnDragOver}
        onDrop={(event) => apDndDropOnSlot(event, slotIndex)}
        onClick={() => apDndSlotClick(slotIndex)}
        draggable={!isAnswerChecked && Boolean(optionId)}
        onDragStart={(event) => optionId && apDndDragStartOption(event, optionId)}
        disabled={isAnswerChecked}
      >
        {value && <span className='decision-dnd-slot-bc-filled-style'>{value}</span>}
      </button>
    );
  };

  return (
    <div className="quiz-content-scroll-bc">
      <div className="explanation-lesoon-container-bc">
        <div className="title-simple-select-align">
          <p className="centred-simple-element">{currentQuestion.question}</p>
        </div>

        <div className="activ-pasiv-dnd-container-bc">
          <div className="activ-pasiv-dnd-header-bc">
            <span className="activ-pasiv-dnd-col-title-bc">Activ</span>
            <span className="activ-pasiv-dnd-equals-bc">=</span>
            <span className="activ-pasiv-dnd-col-title-bc">Pasiv</span>
          </div>
          <div className="activ-pasiv-dnd-divider-bc" />
          <div className="activ-pasiv-dnd-columns-bc">
            <div className="activ-pasiv-dnd-col-bc">
              {Array.from({ length: apActivCount }, (_, idx) => apRenderSlot(idx))}
            </div>
            <div className="activ-pasiv-dnd-col-spacer-bc" />
            <div className="activ-pasiv-dnd-col-bc">
              {Array.from({ length: apPasivCount }, (_, idx) => apRenderSlot(apActivCount + idx))}
            </div>
          </div>
        </div>

        {!isAnswerChecked && (
          <div
            className="decision-dnd-options-bc"
            onDragOver={apDndOnDragOver}
            onDrop={apDndDropOnOptions}
          >
            {apNormalizedOptions.map((option) => {
              const isUsed = generalDragAnswer.includes(option.id);
              return (
                <button
                  key={option.id}
                  type="button"
                  className={`decision-dnd-option-bc ${isUsed ? 'used' : ''}`}
                  draggable={!isUsed}
                  onDragStart={(event) => !isUsed && apDndDragStartOption(event, option.id)}
                  onClick={() => !isUsed && apDndOptionClick(option.id)}
                  disabled={isUsed}
                >
                  {!isUsed && option.label}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}


case 'decisionFlowApplication':
  return (
    <DecisionFlowApplication
      question={currentQuestion}

      decisionPhase={decisionPhase}
      decisionStepIndex={decisionStepIndex}

      decisionAnswer={decisionAnswer}

      decisionSelectedAnswers={
        decisionSelectedAnswers
      }

      shuffledOptions={
        shuffledDecisionOptions
      }

      dragOptions={
        shuffledDecisionDragOptions
      }

      dragAnswers={
        decisionDragAnswer
      }

      formulaOptions={
        shuffledFormulaDragOptions
      }

      formulaAnswers={
        formulaDragAnswers
      }

 onFormulaAnswersChange={(nextAnswers) => {
  const safeNextAnswers =
    nextAnswers &&
    typeof nextAnswers === 'object' &&
    !Array.isArray(nextAnswers)
      ? nextAnswers
      : {};

  setFormulaDragAnswers(safeNextAnswers);

  const currentStep =
    currentQuestion.steps?.[
      decisionStepIndex
    ];

  const expectedAnswers =
    currentStep?.correctAnswer &&
    typeof currentStep.correctAnswer === 'object' &&
    !Array.isArray(currentStep.correctAnswer)
      ? currentStep.correctAnswer
      : {};

  const requiredSlotIds =
    Object.keys(expectedAnswers);

  const allSlotsFilled =
    requiredSlotIds.length > 0 &&
    requiredSlotIds.every(
      (slotId) =>
        safeNextAnswers[slotId] !== null &&
        safeNextAnswers[slotId] !== undefined &&
        safeNextAnswers[slotId] !== ''
    );

  setDesableButton(!allSlotsFilled);
  setTextButton('Verifica');
  setChangeColorButton(allSlotsFilled);
}}
      isAnswerChecked={
        isAnswerChecked
      }

      onSimpleAnswerChange={
        handleDecisionSimpleAnswer
      }

      onMultipleAnswerChange={
        handleDecisionMultipleAnswer
      }

      classificationAnswers={
        classificationAnswers
      }

      onClassificationAnswersChange={
        handleClassificationAnswersChange
      }

      onDragAnswersChange={(nextAnswers) => {
        const safeNextAnswers =
          Array.isArray(nextAnswers)
            ? nextAnswers
            : [];

        setDecisionDragAnswer(
          safeNextAnswers
        );

        const currentStep =
          currentQuestion.steps?.[
            decisionStepIndex
          ];

        const requiredSlotsCount =
          getDecisionDragSlotsCount(
            currentStep
          );

        const allSlotsFilled =
          requiredSlotsCount > 0 &&
          safeNextAnswers.length ===
            requiredSlotsCount &&
          safeNextAnswers.every(
            (answer) =>
              answer !== null &&
              answer !== undefined &&
              answer !== ''
          );

        setDesableButton(
          !allSlotsFilled
        );

        setTextButton(
          'Verifica'
        );

        setChangeColorButton(
          allSlotsFilled
        );
      }}

      onDragSelectionChange={() => {}}

      getOptionValueById={
        getDecisionOptionValueById
      }

      getSlotsCount={
        getDecisionDragSlotsCount
      }

      finalImage={
        contiRevendicat
      }
    />
  );
        case 'manualInput':
          return (
            <div className="quiz-content-scroll-bc">
            <div className='explanation-lesoon-container-bc'>
              <h4 className='tittle-sescrition-lesson'><strong>{currentQuestion.question}</strong></h4>
        
              <div className='align-input-items'>
                {currentQuestion.correctAnswer.map((answer, index) => {
                  const isCorrect = Number(userInput[index]) === answer.code; // Verifică dacă răspunsul este corect
                  const inputClass = isAnswerChecked
                    ? isCorrect
                      ? 'answer-input-correct'
                      : 'answer-input-incorrect'
                    : 'answer-input-item-complete';
        
                  return (
                    <div className='' key={index}>
                      <div className='input-item-answer-type'>
                        <input
                          className={inputClass}
                          type="number"
                          maxLength='4'
                          value={userInput[index] || ''}
                          onChange={(e) => { 
                            handleInputChange(index, e.target.value); 
                            setDesableButton(false);
                          }}
                          disabled={isAnswerChecked}
                        />
                        <p className='input-title-element-answer'>{answer.label}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            </div>
          );


          

case 'dragAndDropHorizontal': {
  const normalizedOptions =
    shuffledDragHorizontalOptions.length
      ? shuffledDragHorizontalOptions
      : normalizeHorizontalDragOptions(
          currentQuestion
        );

  const slotsCount =
    getHorizontalDragSlotsCount(
      currentQuestion
    );

  const expectedAnswers =
    getHorizontalDragExpectedAnswers(
      currentQuestion
    ).map((item) => String(item));

  const rows =
    getHorizontalDragRows(
      currentQuestion
    );

  const sentenceSegments =
    getHorizontalSentenceSegments(
      currentQuestion
    );

  return (
    <DragAndDropHorizontal
      question={currentQuestion}
      options={normalizedOptions}
      selectedAnswers={dataReceived}
      isAnswerChecked={isAnswerChecked}

      slotsCount={slotsCount}
      expectedAnswers={expectedAnswers}
      rows={rows}
      sentenceSegments={sentenceSegments}

      getOptionValueById={
        getHorizontalOptionValueById
      }

      onAnswersChange={
        handleHorizontalDragAnswersChange
      }
    />
  );
}


case 'associationOption':
  return (
    <AssociationOption
      question={currentQuestion}
      answers={associationAnswers}
      isAnswerChecked={isAnswerChecked}
      onAnswersChange={
        handleAssociationAnswersChange
      }
      onComplete={
        handleAssociationComplete
      }
    />
  );
         
          
case 'multipleSelect':
  return (
    <MultipleSelectQuiz
      question={currentQuestion}
      options={shuffledMultipleOptions}
      selectedAnswers={selectedAnswers}
      isAnswerChecked={isAnswerChecked}
      onToggleAnswer={handleMultipleAnswerToggle}
    />
  );


        case 'optionDragAndDropFormulaLeft': {
          const odflNormalizedOptions = (shuffledOptionDragAndDropFormulaLeftOptions.length
            ? shuffledOptionDragAndDropFormulaLeftOptions
            : (currentQuestion.options || [])
          ).map((option, index) => {
            if (option && typeof option === 'object') {
              const value = option.code ?? option.value ?? option.label ?? '';
              const label = option.label ?? option.code ?? option.value ?? '';
              return { id: option.id ?? `${String(value)}-${index}`, value: String(value), label: String(label) };
            }
            return { id: `${String(option)}-${index}`, value: String(option), label: String(option) };
          });

          const odflSlotsCount = Array.isArray(currentQuestion.correctAnswer) && currentQuestion.correctAnswer.length > 0
            ? currentQuestion.correctAnswer.length
            : 8;

          const odflTopCount = currentQuestion.topRowCount ?? 4;
          const odflLeftCount = currentQuestion.leftColCount ?? Math.floor((odflSlotsCount - odflTopCount) / 2);
          const odflRightCount = odflSlotsCount - odflTopCount - odflLeftCount;

          const odflExpected = Array.isArray(currentQuestion.correctAnswer)
            ? currentQuestion.correctAnswer.map((item) => String(item))
            : [];

          const odflOnDragOver = (event) => event.preventDefault();

          const odflDragStartOption = (event, value) => {
            if (isAnswerChecked) return;
            event.dataTransfer.setData('text/plain', String(value));
            event.dataTransfer.effectAllowed = 'move';
          };

          const odflPlaceInSlot = (slotIndex, value) => {
            if (isAnswerChecked || value === null || value === undefined || value === '') return;
            setDataReceived((prev) => {
              const next = Array.isArray(prev) && prev.length === odflSlotsCount
                ? [...prev]
                : Array(odflSlotsCount).fill(null);
              const existingIndex = next.findIndex((item) => item === String(value));
              if (existingIndex !== -1 && existingIndex !== slotIndex) next[existingIndex] = null;
              next[slotIndex] = String(value);
              return next;
            });
            setTextButton('Verifica');
            setChangeColorButton(true);
          };

          const odflDropOnSlot = (event, slotIndex) => {
            event.preventDefault();
            if (isAnswerChecked) return;
            odflPlaceInSlot(slotIndex, event.dataTransfer.getData('text/plain'));
          };

          const odflDropOnOptions = (event) => {
            event.preventDefault();
            if (isAnswerChecked) return;
            const value = event.dataTransfer.getData('text/plain');
            if (value) setDataReceived((prev) => prev.map((item) => (item === value ? null : item)));
          };

          const odflSlotClick = (slotIndex) => {
            if (isAnswerChecked) return;
            setDataReceived((prev) => { const n = [...prev]; n[slotIndex] = null; return n; });
          };

          const odflOptionClick = (value) => {
            if (isAnswerChecked || dataReceived.includes(String(value))) return;
            const firstEmpty = dataReceived.findIndex((item) => item === null || item === undefined);
            if (firstEmpty !== -1) odflPlaceInSlot(firstEmpty, value);
          };

          const odflDragStartSlot = (event, value) => {
            if (isAnswerChecked || !value) return;
            event.dataTransfer.setData('text/plain', String(value));
            event.dataTransfer.effectAllowed = 'move';
          };

          const renderOdflSlot = (slotIndex) => {
            const value = dataReceived[slotIndex] || '';
            const expected = odflExpected[slotIndex] || '';
            const isCorrectSlot = isAnswerChecked && value && value === expected;
            const isWrongSlot = isAnswerChecked && value && value !== expected;
            return (
              <button
                key={`odfl-slot-${slotIndex}`}
                type="button"
                className={`mfl-slot-bc ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                onDragOver={odflOnDragOver}
                onDrop={(e) => odflDropOnSlot(e, slotIndex)}
                onClick={() => odflSlotClick(slotIndex)}
                draggable={!isAnswerChecked && Boolean(value)}
                onDragStart={(e) => odflDragStartSlot(e, value)}
                disabled={isAnswerChecked}
              >
                <span className='mfl-slot-value-bc'>{value}</span>
              </button>
            );
          };

          return (
            <div className="quiz-content-scroll-bc">
              <div className='explanation-lesoon-container-bc mfl-shell-bc'>
                <div className='title-simple-select-align-bc siple-formula-title-wrap-bc'>
                  <p className='question-text-bc siple-formula-question-bc'>{currentQuestion.question}</p>
                </div>

                {/* Top row */}
                <div className='mfl-top-row-bc'>
                  {Array.from({ length: odflTopCount }, (_, i) => renderOdflSlot(i))}
                </div>

                {/* Middle section: left column + spacer + right column */}
                <div className='mfl-middle-section-bc'>
                  <div className='mfl-col-bc'>
                    {Array.from({ length: odflLeftCount }, (_, i) => renderOdflSlot(odflTopCount + i))}
                  </div>
                  <div className='mfl-col-spacer-bc' />
                  <div className='mfl-col-bc'>
                    {Array.from({ length: odflRightCount }, (_, i) => renderOdflSlot(odflTopCount + odflLeftCount + i))}
                  </div>
                </div>

                {/* Options */}
                {!isAnswerChecked && (
                  <div
                    className='mfl-options-bc'
                    onDragOver={odflOnDragOver}
                    onDrop={odflDropOnOptions}
                  >
                    {odflNormalizedOptions.map((option) => {
                      const isUsed = dataReceived.includes(option.value);
                      return (
                        <button
                          key={option.id}
                          type="button"
                          className={`mfl-option-bc ${isUsed ? 'used' : ''}`}
                          draggable={!isUsed}
                          onDragStart={(e) => !isUsed && odflDragStartOption(e, option.value)}
                          onClick={() => !isUsed && odflOptionClick(option.value)}
                          disabled={isUsed}
                        >
                          {!isUsed && option.label}
                        </button>
                      );
                    })}
                  </div>
                )}

                <div className='position-button-lesson-bc'>
                  <button
                    className={`button-next-quiz-bc ${areAllFieldsCompleted() ? '' : 'button-next-quiz-desabled-bc'}`}
                    onClick={verifyAnswer}
                    disabled={!areAllFieldsCompleted()}
                  >
                    Verifica
                  </button>
                </div>
              </div>
            </div>
          );
        }

        case 'optionDragAndDropFormulaRight': {
          const odfrNormalizedOptions = (shuffledOptionDragAndDropFormulaRightOptions.length
            ? shuffledOptionDragAndDropFormulaRightOptions
            : (currentQuestion.options || [])
          ).map((option, index) => {
            if (option && typeof option === 'object') {
              const value = option.code ?? option.value ?? option.label ?? '';
              const label = option.label ?? option.code ?? option.value ?? '';
              return { id: option.id ?? `${String(value)}-${index}`, value: String(value), label: String(label) };
            }
            return { id: `${String(option)}-${index}`, value: String(option), label: String(option) };
          });

          const odfrSlotsCount = Array.isArray(currentQuestion.correctAnswer) && currentQuestion.correctAnswer.length > 0
            ? currentQuestion.correctAnswer.length
            : 8;

          const odfrTopCount = currentQuestion.topRowCount ?? 4;
          const odfrRemaining = Math.max(0, odfrSlotsCount - odfrTopCount);
          const odfrMidLeftCount = currentQuestion.rightInnerColCount ?? Math.floor(odfrRemaining / 2);
          const odfrMidRightCount = odfrRemaining - odfrMidLeftCount;

          const odfrExpected = Array.isArray(currentQuestion.correctAnswer)
            ? currentQuestion.correctAnswer.map((item) => String(item))
            : [];

          const odfrOnDragOver = (event) => event.preventDefault();

          const odfrDragStartOption = (event, value) => {
            if (isAnswerChecked) return;
            event.dataTransfer.setData('text/plain', String(value));
            event.dataTransfer.effectAllowed = 'move';
          };

          const odfrPlaceInSlot = (slotIndex, value) => {
            if (isAnswerChecked || value === null || value === undefined || value === '') return;
            setDataReceived((prev) => {
              const next = Array.isArray(prev) && prev.length === odfrSlotsCount
                ? [...prev]
                : Array(odfrSlotsCount).fill(null);
              const existingIndex = next.findIndex((item) => item === String(value));
              if (existingIndex !== -1 && existingIndex !== slotIndex) next[existingIndex] = null;
              next[slotIndex] = String(value);
              return next;
            });
            setTextButton('Verifica');
            setChangeColorButton(true);
          };

          const odfrDropOnSlot = (event, slotIndex) => {
            event.preventDefault();
            if (isAnswerChecked) return;
            odfrPlaceInSlot(slotIndex, event.dataTransfer.getData('text/plain'));
          };

          const odfrDropOnOptions = (event) => {
            event.preventDefault();
            if (isAnswerChecked) return;
            const value = event.dataTransfer.getData('text/plain');
            if (value) setDataReceived((prev) => prev.map((item) => (item === value ? null : item)));
          };

          const odfrSlotClick = (slotIndex) => {
            if (isAnswerChecked) return;
            setDataReceived((prev) => { const n = [...prev]; n[slotIndex] = null; return n; });
          };

          const odfrOptionClick = (value) => {
            if (isAnswerChecked || dataReceived.includes(String(value))) return;
            const firstEmpty = dataReceived.findIndex((item) => item === null || item === undefined);
            if (firstEmpty !== -1) odfrPlaceInSlot(firstEmpty, value);
          };

          const odfrDragStartSlot = (event, value) => {
            if (isAnswerChecked || !value) return;
            event.dataTransfer.setData('text/plain', String(value));
            event.dataTransfer.effectAllowed = 'move';
          };

          const renderOdfrSlot = (slotIndex) => {
            const value = dataReceived[slotIndex] || '';
            const expected = odfrExpected[slotIndex] || '';
            const isCorrectSlot = isAnswerChecked && value && value === expected;
            const isWrongSlot = isAnswerChecked && value && value !== expected;
            return (
              <button
                key={`odfr-slot-${slotIndex}`}
                type="button"
                className={`mfl-slot-bc ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                onDragOver={odfrOnDragOver}
                onDrop={(e) => odfrDropOnSlot(e, slotIndex)}
                onClick={() => odfrSlotClick(slotIndex)}
                draggable={!isAnswerChecked && Boolean(value)}
                onDragStart={(e) => odfrDragStartSlot(e, value)}
                disabled={isAnswerChecked}
              >
                <span className='mfl-slot-value-bc'>{value}</span>
              </button>
            );
          };

          return (
            <div className="quiz-content-scroll-bc">
              <div className='explanation-lesoon-container-bc mfl-shell-bc'>
                <div className='title-simple-select-align-bc siple-formula-title-wrap-bc'>
                  <p className='question-text-bc siple-formula-question-bc'>{currentQuestion.question}</p>
                </div>

                <div className='mfl-top-row-bc'>
                  {Array.from({ length: odfrTopCount }, (_, i) => renderOdfrSlot(i))}
                </div>

                <div className='mfr-middle-section-bc'>
                  <div className='mfr-col-spacer-bc' />
                  <div className='mfr-col-bc'>
                    {Array.from({ length: odfrMidLeftCount }, (_, i) => renderOdfrSlot(odfrTopCount + i))}
                  </div>
                  <div className='mfr-col-bc'>
                    {Array.from({ length: odfrMidRightCount }, (_, i) => renderOdfrSlot(odfrTopCount + odfrMidLeftCount + i))}
                  </div>
                </div>

                {!isAnswerChecked && (
                  <div
                    className='mfl-options-bc'
                    onDragOver={odfrOnDragOver}
                    onDrop={odfrDropOnOptions}
                  >
                    {odfrNormalizedOptions.map((option) => {
                      const isUsed = dataReceived.includes(option.value);
                      return (
                        <button
                          key={option.id}
                          type="button"
                          className={`mfl-option-bc ${isUsed ? 'used' : ''}`}
                          draggable={!isUsed}
                          onDragStart={(e) => !isUsed && odfrDragStartOption(e, option.value)}
                          onClick={() => !isUsed && odfrOptionClick(option.value)}
                          disabled={isUsed}
                        >
                          {!isUsed && option.label}
                        </button>
                      );
                    })}
                  </div>
                )}

                <div className='position-button-lesson-bc'>
                  <button
                    className={`button-next-quiz-bc ${areAllFieldsCompleted() ? '' : 'button-next-quiz-desabled-bc'}`}
                    onClick={verifyAnswer}
                    disabled={!areAllFieldsCompleted()}
                  >
                    Verifica
                  </button>
                </div>
              </div>
            </div>
          );
        }


        case 'lessonResume':
          if (finalMessage) {
            return null;
          }
          return (
            <div className='explanation-lesoon-container-resume-bc'>
              <div className="description-lesson-text-explanation-resume">
                <h2 className="motivational-title">{currentQuestion.titleExplanation}</h2>
                <div className='container-resume-lesson-bc'>
                  {currentQuestion.descriptionExplanation.map((description, index) => (
                    <div
                      key={index}
                      className="summary-info-line-bc"
                      style={{ animationDelay: `${index * 0.3}s` }}
                    >
                      <div>
                        <FontAwesomeIcon 
                          icon={faCheckDouble} 
                          className="summary-icon-resume-bc"
                        />
                      </div>
                      <div
                        className="text-size-emplanation-resume-bc"
                        dangerouslySetInnerHTML={{ __html: description }}
                      ></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );




          case 'JustInTimeMotivation':
  return (
   
      <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">
          {currentQuestion.descriptionExplanation.map((explanation, index) => (
            <div
              key={index}
              className="text-size-emplanation-bc"
              dangerouslySetInnerHTML={{ __html: explanation }}
            ></div>
          ))}
          
        <MotivationStats
  coins={lessonCoins}
  xp={lessonXp}
  correct={correctAnswersCount}
  wrong={wrongAnswersCount}
/>

    
        </div>
      </div>
    
  );

          
  case 'serieCompleta':
  return (
    
      <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">
          <h2 className="motivational-title">{currentQuestion.titleExplanation}</h2>
        
        
            <div className="lesson-image-container">
            <StreakDisplay />
            </div>
          
        </div>
      </div>
    
  );

  case 'deblocarePremium':
  return (
   
      <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">
          <h2 className="motivational-title">{currentQuestion.titleExplanation}</h2>
          
          
           <div className="lesson-image-container">

  {/* LISTA BENEFICII PREMIUM */}
  <div className="premium-benefits-box">
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la lecțiile standard
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la lecțiile de practică
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la aplicații
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la testele de final de capitol
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Certificat de finalizare a cursului
    </div>
  </div>

  {/* BUTOANE */}
  <div className="premium-buttons">
    <button className="premium-activate-btn">Activează acum</button>
    <button className="premium-remind-btn">Amintește-mi mai târziu</button>
  </div>

</div>

          
        </div>
      </div>
   
  );

  case 'clasament':
  return (
    <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">

        <h2 className="motivational-title">Clasament XP</h2>

        <Leaderboard />   {/* 🔥 Componenta nouă */}

      </div>
    </div>
  );



      default:
        return <p>Tipul întrebării nu este recunoscut.</p>;
    }

    

  };


  const currentQuestion = lessonData?.questions?.[nextQuestion];




// 🔹 UI logic pentru explanationLesson si formulaExplanationLesson
const isExplanationCardLesson =
  currentQuestion?.type === 'explanationLesson' ||
  currentQuestion?.type === 'formulaExplanationLesson';

const totalCards =
  isExplanationCardLesson && Array.isArray(currentQuestion?.descriptionExplanation)
    ? currentQuestion.descriptionExplanation.length + (currentQuestion?.type === 'formulaExplanationLesson' ? 1 : 0)
    : 0;

const isExplanationContinueLocked =
  isExplanationCardLesson &&
  totalCards > 1 &&
  !hasUnlockedExplanationContinue;


const currentExplanation = (() => {
  if (!currentQuestion) return null;

  if (currentQuestion.type === 'decisionFlowApplication') {
    return currentQuestion.steps?.[decisionStepIndex]?.explanation || null;
  }

  return currentQuestion.explanation || null;
})();

const isWaitingTopProgress =
  !isLessonFinished &&
  !noTransitionTypes.includes(currentType) &&
  (!isTopProgressReady || pendingLessonCompletionAdvance);

const contentTransitionKey =
  currentType === 'decisionFlowApplication'
    ? `${nextQuestion}-${decisionPhase}-${decisionStepIndex}`
    : `${nextQuestion}`;

const showDecisionFlowContextButton =
  currentQuestion?.type === 'decisionFlowApplication' &&
  decisionPhase === 'steps' &&
  textButton === 'Verifica';
const isGiftLessonScreen = currentQuestion?.type === 'giftlesson';
const isExplanationLessonScreen = currentType === 'explanationLesson';

useEffect(() => {
  if (!isGiftLessonScreen) {
    document.documentElement.classList.remove('gift-no-scroll');
    document.body.classList.remove('gift-no-scroll');
    return;
  }

  document.documentElement.classList.add('gift-no-scroll');
  document.body.classList.add('gift-no-scroll');

  return () => {
    document.documentElement.classList.remove('gift-no-scroll');
    document.body.classList.remove('gift-no-scroll');
  };
}, [isGiftLessonScreen]);



  return (

 
    
    <div className='container-bc-general'>
  

      {/* Bara de progres și elementele de sus dezactivate complet după verificare, ca la explanationLesson */}
      <div className={`position-progress-bar${isAnswerChecked && !isExplanationCardLesson ? ' disabled-top-bar' : ''}`}>
        {!isLessonFinished && !showJumpHereIntro && !isGiftLessonScreen && (
          <StatusProgres 
            width={calculateProgress()}
            coinCount={coinCount}
            lessonCoinsEarned={lessonCoins}
            hideCoinsPopup={isReplayLesson}
            onExitClick={handleExitClick}
            onEyeClick={handleShowEyePopup}
            livesCount={lives}   
            lessonType={currentType}
            quizExplanation={currentExplanation}
            showCardDots={isExplanationCardLesson && totalCards > 1}
            totalCards={totalCards}
            activeCardIndex={cardIndex}
     
            onProgressAnimationStateChange={setIsTopProgressReady}
            onRevealAnswer={handleRevealAnswer}
            isContextShowing={currentQuestion?.type === 'decisionFlowApplication' && (decisionPhase === 'intro' || decisionPhase === 'final')}
            disableHeaderElements={isAnswerChecked && !isExplanationCardLesson}
          />
        )}
      </div>
  
      {/* Conținutul principal al lecției - păstrat vizibil indiferent de starea isLessonFinished */}


{showJumpHereIntro ? (
  <div className='position-main-lesson-bc'>
    <div className='jump-here-intro-container-bc'>
      <img
        src={Junphereconti}
        alt='Jump Here'
        className='jump-here-intro-image-bc'
      />
      <div className='jump-here-intro-actions-bc'>
        <button
          className='jump-here-intro-later-btn-bc'
          onClick={() => navigate('/functionalpagelogin')}
        >
          Poate mai tarziu
        </button>
        <button
          className='button-next-quizbc jump-here-intro-start-btn-bc'
          onClick={() => setShowJumpHereIntro(false)}
        >
          Incepe
        </button>
      </div>
    </div>
  </div>
) : (
  <div
    key={contentTransitionKey}
    className={`position-main-lesson-bc lesson-screen-transition-bc ${isExplanationLessonScreen ? 'lesson-screen-transition-left-bc' : ''}`}
  >
    {renderContent()}
  </div>
)}




  
      {/* Secțiunea butonului */}


{!showJumpHereIntro && !isGiftLessonScreen && (
<LessonActionBar
  show={
    currentQuestion?.type !==
    'associationOption'
  }

  showPracticeHelp={showPracticeHelp}

  hidden={hideActionButton}

  updateCardIndexWithSwipe={handleCardChange}

  currentQuestion={currentQuestion}
  lessonData={lessonData}

  feedbackLessonRef={feedbackLessonRef}
  hasLessonFeedback={hasLessonFeedback}

  nextQuestion={nextQuestion}
  currentType={currentType}

  textButton={textButton}
  desableButon={desableButon}
  changeColorButton={changeColorButton}

  isLessonFinished={isLessonFinished}
  finalMessage={finalMessage}

  isLessonCompletionBarDone={
    isLessonCompletionBarDone
  }

  isWaitingTopProgress={
    isWaitingTopProgress
  }

  isAnswerChecked={isAnswerChecked}
  showCorrectAnswer={showCorrectAnswer}
  simpleCorrectAnswer={simpleCorrectAnswer}

  isExplanationCardLesson={
    isExplanationCardLesson
  }

  isExplanationContinueLocked={
    isExplanationContinueLocked
  }

  totalCards={totalCards}
  cardIndex={cardIndex}

  decisionPhase={decisionPhase}
  decisionStepIndex={decisionStepIndex}

  lessonXp={lessonXp}
  lessonCoins={lessonCoins}

  /* ASTEA LIPSEAU */
  coinCount={coinCount}
  onRevealAnswer={handleRevealAnswer}
  onSpendCoins={addCoins}

  lessonCompletionSentRef={
    lessonCompletionSentRef
  }

  changeCardImage={changecard}
  contextImage={infoButton}

  verifyAnswer={verifyAnswer}
  toNextQuestion={toNextQuestion}
  finalizeLesson={finalizeLesson}

  sendLessonCompletion={
    sendLessonCompletion
  }

  sendLessonFinishXp={sendLessonFinishXp}
  addCoins={addCoins}
  updateDailyMissions={updateDailyMissions}

  handleHideFeedback={handleHideFeedback}
  setShowFeedback={setShowFeedback}

  setHideActionButton={
    setHideActionButton
  }

  setShowPracticeHelp={
    setShowPracticeHelp
  }

  setDecisionPhase={setDecisionPhase}

  setDecisionStepIndex={
    setDecisionStepIndex
  }

  setDecisionAnswer={
    setDecisionAnswer
  }

  setDecisionSelectedAnswers={
    setDecisionSelectedAnswers
  }

  setDecisionDragAnswer={
    setDecisionDragAnswer
  }

  setIsAnswerChecked={
    setIsAnswerChecked
  }

  setAnswerStatus={
    setAnswerStatus
  }

  setDesableButton={
    setDesableButton
  }

  setTextButton={
    setTextButton
  }

  setChangeColorButton={
    setChangeColorButton
  }
/>
)}


  
      {/* Alerta de părăsire a lecției */}
   {showAlert && (
  <CustomAlert
    onConfirm={handleConfirmExit}
    onCancel={handleCancelExit}
  />
)}



{showFeedback && isAnswerChecked && (
  <FeedbackPopup
    status={answerStatus}
     messageCorrect={correctStreak === 5 ? "5 la rând!" : "Corect!"}
  xpAmount={correctStreak === 5 ? 30 : 10}   // 🔥 trimitem XP corect
  isStreakBonus={correctStreak === 5}
    message={message}
    chapterId={chapterId}
    lessonId={lessonId}
    questionIndex={nextQuestion}   // 🔥 cheia pentru comentarii pe fiecare întrebare
    onClose={handleHideFeedback}
    onContinue={() => {
 

  if (correctStreak === 5) {
    setCorrectStreak(0);
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  // 🔥 DACĂ SUNTEM ÎN decisionFlowApplication
if (currentQuestion.type === 'decisionFlowApplication') {
  handleHideFeedback();

  // după feedback -> pas următor / final
  if (decisionStepIndex < currentQuestion.steps.length - 1) {
    setDecisionStepIndex(prev => prev + 1);
    setDecisionAnswer(null);
    setDecisionSelectedAnswers([]);
    setDecisionDragAnswer([]);
    setIsAnswerChecked(false);
    setAnswerStatus(null);
    setDesableButton(true);
    setTextButton('Verifica');
    setChangeColorButton(false);
  } else {
    setDecisionPhase('final');
    setDecisionAnswer(null);
    setDecisionSelectedAnswers([]);
    setDecisionDragAnswer([]);
    setIsAnswerChecked(false);
    setAnswerStatus(null);
    setDesableButton(false);
    setTextButton('Continua');
    setChangeColorButton(false);
  }

  setHideActionButton(false);
  return;
}



  // 🔥 RESTUL QUIZURILOR
  toNextQuestion();
  setHideActionButton(false);
}}


    onShowAnswer={() => {
      setShowExplanationPopupModal(true);
      handleHideFeedback();
    }}
  />
)}



{showExplanationPopupModal && currentExplanation && (
  <ExplanationPopup
    explanation={currentExplanation}
    onContinue={() => {
      setShowExplanationPopupModal(false);

      const currentQuestion =
        lessonData?.questions?.[nextQuestion];

      if (!currentQuestion) {
        setHideActionButton(false);
        return;
      }

      if (
        currentQuestion.type ===
        'decisionFlowApplication'
      ) {
        const steps = Array.isArray(
          currentQuestion.steps
        )
          ? currentQuestion.steps
          : [];

        if (
          decisionStepIndex <
          steps.length - 1
        ) {
          setDecisionStepIndex(
            (previousIndex) =>
              previousIndex + 1
          );

          setDecisionAnswer(null);
          setDecisionSelectedAnswers([]);
          setDecisionDragAnswer([]);

          setIsAnswerChecked(false);
          setAnswerStatus(null);

          setDesableButton(true);
          setTextButton('Verifica');
          setChangeColorButton(false);
        } else {
          setDecisionPhase('final');

          setDecisionAnswer(null);
          setDecisionSelectedAnswers([]);
          setDecisionDragAnswer([]);

          setIsAnswerChecked(false);
          setAnswerStatus(null);

          setDesableButton(false);
          setTextButton('Continua');
          setChangeColorButton(false);
        }

        setHideActionButton(false);
        return;
      }

      toNextQuestion();
      setHideActionButton(false);
    }}
  />
)}

{showNoLivesPopup && (
  <NoLivesPopup
    onClose={() => navigate('/functionalpagelogin')}
    availableCoins={coinCount}
    lifePrice={LIFE_PURCHASE_PRICE}
    onBuyLife={handleBuyLifeForCurrentLesson}
    onContinue={handleContinueAfterBuyingLife}
  />
)}


{showPracticeHelp && (
  <PracticeHelpPopup
    text={currentQuestion.context}
    onClose={() => setShowPracticeHelp(false)}
  />
)}





    </div>
  );
  



  
};



export default Chaptercontainer;